import Vue from 'vue'
import VueI18n from 'vue-i18n'
import router from "../router";

Vue.use(VueI18n)

const messages = {
    en: {
        actions: "Actions",
        active: "Active",
        add: "Add",
        addDebt: "Add debt",
        debtPayingTime: "Debt payment date",
        debtPayingTimeNotCome: "Debt payment date has not yet arrived",
        debtPayingTimeCome: "Due date has come",
        debtPayingTimeGone: "Due date has passed",
        additional: "Additional",
        additionalInformation: "Additional Information",
        advice: "Advice",
        amount: "Amount",
        boughtPrice: "Bought price",
        beforeLeaveAdvice: 'Do you really want to leave? You have unsaved changes!',
        cancel: "Cancel",
        category: "Category",
        collapseSidebar:"Collapse sidebar",
        connectionRefused: "Connection Refused",
        currency: "Currency",
        createdAt: "Created At",
        date: "Date",
        debt: "Debt",
        debtAmount: "Debt amount",
        delete: "Delete",
        download: 'Download',
        cancelDelete: "Don't delete",
        deleteConfirm: "Are you sure to delete \"{name}\"?",
        deleteConfirmSimple: "Are you sure you want to delete?",
        detailed: "More",
        edit: "Edit",
        errorData: "Error",
        errorDate: "Invalid date entered",
        empty: "Empty",
        export: "Create file for scales",
        goBack: "Go back",
        hasPayed: "Has payed?",
        home: "Home",
        id: "ID",
        loginSystem: "Login to the system",
        main: "Main",
        more: "More",
        moreInfo: "More info",
        move: "Move",
        name: "Name",
        new: "New",
        no: "No",
        noData: "No data",
        notInfo: "The information you were looking for was not found",
        ok: "Ok",
        onCredit: "On credit",
        overPayed: "The amount is more than the loan amount",
        pay: "Pay",
        payed: "Payed",
        payedAmount: "Payment amount",
        payType: "Pay type",
        payDebt: "Pay to debt",
        payWarning: "Attention! Do you really want to pay the following amount?",
        profile: 'Profile',
        purchase: "Purchase",
        purchasePerUnit: "Purchase price per unit ",
        price: "Price",
        pcs: 'pcs',
        print: "Print",
        refresh: "Refresh",
        refreshInfo: "Updating information...",
        save: "Save",
        search: "Search",
        select: "Select",
        selected: "Selected",
        selectError: "Sorry, no matching options",
        sellingPrice: "Selling price",
        saved: "Saved",
        technicalWorks: "Technical works are being carried out in order to improve the quality of service",
        total: "Total",
        totalBalance: "Total balance",
        totalSalesAmount: 'Total purchase amount',
        totalPrice: "Total price",
        transactions: "Transactions",
        trash: "Deleted products",
        treeView: "Tree view",
        unknownError: 'Unknown error :(',
        view: "View",
        warning: "Warning",
        yes: "Yes",
        year: "Year",
        loss: 'Loss',
        atWork: {
            atWork: "At work",
            againEntry: "You want to login again",
            againEntryReason: "Reason for re-entry",
            cantEntry: "There is a limit on system reuse",
            limit: "Allowed number of entries: 3 times",
            closeNow: "Close now",
            currentTime: "Current time",
            confirmFinishWork: "Do you approve of leaving work early?",
            ended: "Finished work",
            yourJobTime: "Your working hours",
            greeting: "Hello!",
            startJob: "Get Started",
            started: "Started work",
            today: "Today",
            toJobTime: "Before working hours",
            title: "At work",
            late: "You were late for work",
            lateTime: "Late time",
            reasonLate: "Reason for being late",
            minSymbolAmount: "Please enter at least 10 characters",
            hour: "hour",
            minute: "minute",
            jobTime: "Work time",
            from: "from",
            to: "to",
            reason: "Reason",
            finishWork: "Shutdown",
            wantFinishWorkBeforeTime: "Working time is not over yet. Do you want to leave?",
        },
        autoOrder: {
            title: "Auto order",
            modalTitle: "Auto order dates",
            orderDate: 'Auto order date',
            lastOrderPeriod: 'Last auto order period',
            lastOrderDate: 'Date of last auto order',
            order: 'Order',
            new: 'New auto order',
            daily: 'days',
            period: 'Order period',
            amount: 'Order amount',
            sum: 'Order sum',
            sold: 'Sold',
            soldOutDate: 'Date of end',
            status: 'Order status',
            marja: 'Profit percentage',
            prepared: 'Order prepared',
            saleRate: 'Amount of sale',
            avgSaleRate: 'Sales/day',
            productPriceSum: 'Amount of products (at last purchase price)',
            makeOrder: 'Make order',
            ordered: 'Ordered',
            excelFileForPurchase: 'Excel file for purchase',
            noSale: 'There is no sale for the selected period',
            noNeedOrder: 'No order needed'
        },
        order: {
            onlineOrder: 'Online order'
        },
        debtor: {
            debtSuccessPaid: "The debt was successfully paid",
            indebtedness: "Indebtedness"
        },
        error: {
            purchaseCancel: "Part of the products has been already sold",
            access: "You have not access for this action",
            overLimit: "You cannot add more than the amount allowed by your subscription plan."
        },
        company: {
            owner: "Owner",
            accessTime: 'Company is active until {date}',
            activePeriod: 'Company activity',
            create: "Sign up",
            registeredDate: "Registration date",
            employeesCount: "Employees count",
            name: "Company name",
            telephone: "Phone number",
            namePlaceholder: "Acme",
            title: "Company",
            remaining: {
                productsPrice: "Products worth",
                hasMoney: "Money",
                ourDebt: "Our debt",
                oweUs: "Owe us",
            },
            managerId: "Manager id number",
            managerError: "Manager under this number does not exist",
            month: {
                Jan: 'January',
                Feb: 'February',
                Mar: 'March',
                Apr: 'April',
                May: 'May',
                Jun: 'June',
                Jul: 'July',
                Aug: 'August',
                Sep: 'September',
                Oct: 'October',
                Nov: 'November',
                Dec: 'December',
            },
        },
        companyRequisites: {
            baseCurrency: "Choose main currency",
            tin: "TIN",
            gceo: "GCEO",
            legalAddress: "Legal address",
            physicalAddress: "Physical address",
            chiefDirector: "Chief director",
            addTin: "Add TIN",
            addGceo: "Add GCEO",
            addLegalAddress: "Add legal address",
            addPhysicalAddress: "Add physical address",
            addChiefDirector: "Add chief  director",
            moneyInWallet: "Enter available amount of money"
        },
        customer: {
            add: "Add customer",
            averageCheck: "Average check",
            numberOfCustomers: "Number of customers",
            numberOfDebtors: "Number of customers",
            purchase: "Purchase",
            choose: "Choose customer",
            customers: "Customers",
            canDeleteSaleWarning: "Attention! This employee has the right to delete the entire trading history",
            info: "Customer information",
            dateAdd: "Date Added",
            debtors: "Debtors",
            cashback: {
                title: "cashback",
                amount: "Cashback amount",
                notHaveCashback: "This client does not have cashback!",
                notHaveCashbackCard: "This client does not have a cashback card!",
                residue: "Residual cashback",
                payFromCashback: "Payment with cashback",
                numberNotAvailable: "This number is not available. Please enter another number.",
                totalAmount: "Total cashback amount"
            },
            title: "Customer",
            type: "Type",
            hasDebts: "This customer has debts",
            notExist: "This client is currently unavailable or removed from the system",
            deleteAnyway: "Forget debts and delete",
            deleteCustomWarning: "Attention! This Customer will be completely removed from the system. Can you confirm?",
            personalInformation: "Personal information",
            loyaltyCard: "Loyalty card",
            bankAccountNum: "Bank account number",
            createdAtCompany: "Date of incorporation of the company",
            webSite: "Web-site",
            scoreAndDiscount: "Collect points and make discounts",
            score: "Score",
            discount: "Discount",
            factAddress: "Fact adress",
            firstPurchase: "Date of first purchase",
            opportunities: "Opportunities",
            discountPercent: "Percentage discount",
            totalSalesAmount: "Total sales amount",
            discounted: "Discounted",
            discountAmount: "Discount amount",
        },
        currencyRate: {
            choose: "Choose currency",
            centralBankRate: 'Central bank rate',
            change: 'Change',
            companyRate: 'Enter the currencies rates of the company:',
            currencyRate: 'Currency rates',
            currencyName: 'Currencies names',
            officialRate: 'The official exchange rate of the central bank on the current date: ',
            ourRate: 'Our course:',
            rate: 'Rate',
            rub: 'Russian ruble',
            saveRate: 'Save this course',
            uzs: 'Uzbek sum',
            symbol: 'Symbol',
            usd: 'US dollar',
            sum: 'sum'
        },
        employee: {
            title: "Employee",
            canAuth: "Can authorize",
            position: "Employee position",
            cashier: "Cashier",
            workTimeAndSalary: "Working hours and salary",
            hiredDate: "Employment date. (dd/mm/yyyy)",
            personalInformation: "Personal information",
            belongToApp: "Belong to the system",
            telegram: "Telegram",
            jobEndTime: "{time} minutes left on the clock!",
            jobType: {
                title: "Job type",
                hourly: "Hourly",
                daily: "Daily",
                weekly: "Weekly",
                monthly: "Monthly"
            },
            jobSchedule: {
                title: "Job schedule"
            },
            salary: "Salary",
            wasBornDay: "Was born day:",
            workTimeFrom: "Work time (from)",
            workTimeTo: "Work time (to)"
        },
        excel: {
            row: 'row',
            import: "Import",
            importAgain: "Import again",
            notImport: "Not to be imported",
            choiceExcelFile: 'Choice excel file',
            selectEachColumn: 'Select each column function',
            importedFile: "{lines} rows of data were entered into the base",
            checkData: "Incorrect information sent",
            hasEmptyFields: "Has empty fields",
            validExcel: 'Please upload a valid excel',
            saleCurrency: "Sale currency",
            purchaseCurrency: "Purchase currency",
        },
        expirationProduct: {
            soldOut: "Sold out",
            notSold: "Not sold",
            expiredProductsTotalAmount: "Number of expired products:",
            productsFiveDaysLeftExpire: "Number of products expiring in 5 days:",
            productsTenDaysLeftExpire: "Number of products expiring in 10 days:",
        },
        filter: {
            all: "All",
            clear: "Cleaning",
            filters: "Filters",
            fromAmount: "Amount from",
            fromPrice: "Price from",
            fromDateToDate: "Year-month-date",
            fromSellingPrice: "Selling price from",
            fromSum: "Sum from",
            thisDay: "From this (year-month-date)",
            thisTime: "From this date...",
            toAmount: "Amount to",
            toPrice: "Price to",
            toSellingPrice: "Selling price to",
            toTime: "Untill this date...",
            toDay: "Until this (year-month-date)",
            toSum: "Sum to",
        },
        finance: {
            financialSituation: "Financial situation",
            balance: "Balance",
            title: "Finance",
            counts: "Counts",
            count: "Count",
            report: "Report",
            fromCount: "From count",
            whichCount: "Which count",
            newCount: "New account",
            initialAmount: "Initial amount",
            deleteInfo: "Category deleted successfully!",
            deleteCountInfo: "Count deleted successfully!",
            transfer: "Transfer",
            income: {
                sale: "sale",
                purchase: "purchase",
                rent: "rent",
                salary: "salary",
                communal: "communal",
                debt: "debt",
                credit: "credit",
                paymentSystem: "paymentSystem",
            }
        },
        image: {
            title: "Image",
            choiceImageFile: 'Choice Image',
            validImage: 'Please upload a valid Image'
        },
        import: {
            advice: 'To import products use the <router-link to="https://boshqar.com/" target="_blank">computer version</router-link>',
        },
        incomeAndOutcome: {
            allIncome: "All incomes",
            allOutlay: "All output",
            title: "Income / Output",
            income: "Income",
            outlay: "Output",
            Status: "Status",
        },
        inventory: {
            advice: 'To inventory products use the <router-link to="https://boshqar.com/" target="_blank">computer version</router-link>',
            title: "Inventory",
            result: "Result",
            difference: "Difference",
            sumDifference: "Difference in amount",
            deficit: "Not enough",
            profit: "Redundant",
            amount: "Remaining in the system",
            realAmount: "True remainder",
            allProducts: "All products",
            fitProducts: "Matching Products",
            nonFitProducts: "The products which have difference",
            profitProducts: "Extra products",
            deficitProducts: "Insufficient products",
            finance: "Finance",
            responsiblePerson: "The responsible person",
            sumSelectedProducts: "Sum of selected products",
            sumFitProducts: "The sum of the correct products",
            sumProfitProducts: "The amount of excess products",
            sumDeficitProducts: "Number of missing products",
            sumDifferenceProducts: "The sum of the different products",
            syncing: "Synchronization...",
            synced: "Synchronized",
            sync: "Synchronize"
        },
        kpi: {
            title: "KPI",
            type: "Type of the KPI",
            condition: "Terms of the KPI",
            conditionIssue: "Conditions for issuing KPI",
            forAllProducts: "For all products",
            forSomeProducts: "For some products",
            forExactProduct: "For one product",
            finish: "Finish",
            products: "Products",
            sum: "Plan of the KPI",
            salePlan: "Sales plan",
            saleSum: "Sales amount",
            status: "Status",
            period: {
                title: "Period",
                daily: "Daily",
                weekly: "Weekly",
                monthly: "Monthly"
            },
            onlyActives: "Only active",
            plan: "KPI/Plan",
            planDone: "The plan was done",
            done: "Done",
            indicatorOfEmployees: "Employee performance indicator",
            date: {
                title: "Date",
                startDate: "Start date",
                endDate: "End date"
            },
            daysOfKpi: "Days of the KPI",
            participants: "Participants of the KPI",
            forAllEmployees: "All employees",
            forSomeEmployees: "Some employees",
            employees: "Employees",
            bonus: {
                title: "Bonus",
                forEmployee: "What does the employee receive?",
                onSum: "Bonus on amount",
                fromIncome: "Profit percentage",
                product: "Product",
                percentAmount: "Percent",
                bonusAmount: "Bonus amount",
                given: "Given",
                give: "Give",
                received: "Received",
                notReceived: "Not received"
            },
            employee: {
                title: "Employee name",
            },
            salary: {
                mainTitle: "Salary/Payments",
                salary: "Salary",
                income: "Income",
                title: "Salary",
                payForNewMonth: "Pay for a new month",
                forNewMonth: "For a new month",
                forWhatMonth: "For what month",
                fromWhichCount: "From which count should it be paid?",
                payedAmount: "To pay",
                payed: "Payed",
                pay: "Pay",
                historyOfPay: "Payment history",
                totalPayed: "Total salary paid",
                more: "more",
                payDate: "Date of pay",
            },
        },
        login: {
            title: "Login",
            logout: "Logout",
            success: 'Hi, {login}!',
            error: 'Wrong email or password',
            bye: 'Good bye...',
        },
        notActive: "not active",
        person: {
            title: "Person",
            additionalName: "Middle name",
            age: "old year",
            contacts: "Contacts",
            year: "year",
            givenName: "Given name",
            familyName: "Family name",
            birthday: "Birthday (dd/mm/yyyy)",
            otherInformation: "Other Information",
            fullName: "Full name",
            yourGivenName: "Your given name",
            yourFamilyName: "Your family name",
            telephone: "Phone number",
            telegram: "Telegram",
            gender: {
                title: "Gender",
                man: "Man",
                woman: "Woman",
            },
        },
        plan: {
            title: "Prices",
            compare: "Compare plans",
            hasExpired: "You plan has expired.",
            mainTitle: "The monthly fee for using the system is determined according to the definition plans.",
            subTitle: "If you want to save 17%, we recommend paying for one year.",
            conditions: "The first 7 days of using the system are free! At this time, you can test the system without spending money. The program works at the Premium plan during the free period.",
            statisticsTitle: "Daily, monthly, yearly. Daily income, top products, which product is sold in large quantities, the ability to remotely monitor all transactions in a graphical view",
            statistics: "Statistics",
            employeesCount: "Number of employees",
            warehousesCount: "Number of warehouses",
            suppliersCount: "Number of suppliers",
            customersCount: "Number of customers",
            priceForMonth: "price for month",
            priceForYear: "Price for year with a discount of 17%",
            unlimit: "unlimited",
            feature: "features",
            planChangeWarning: "You are switching to a plan that has lower chances than your current plan. In this case, the number of warehouses will decrease in accordance with your plan, and the excess will be removed. Products from deleted warehouses will be moved to existing warehouses. Do you agree to continue?"
        },
        printView: {
            directorCompany: 'Director',
            totalSum: 'Total sum',
            printA4: 'Print overhead',
            printCheck: 'Print check',
            printEpos: 'Print receipt Epos',
            receipt: "Receipt #",
            addInfo: "Additional information for the receipt"
        },
        product: {
            title: "Product",
            title2: "Products",
            add: "Add product",
            addMany: "Add few",
            name: "Product name",
            choose: "Choose product",
            chooseAndAdd: "Select a product | add",
            count: "Number of products",
            formatBarcode: "enter at least 7 digits",
            barcode: "Barcode",
            hasExpirationDate: "Has no expiration date",
            expirationDate: "Expiration date",
            export: "Export",
            restore: "Restore",
            restoreWarning: "Attention! Selected products will be restored. Do you approve?",
            notRestored: "Unable to restore because the specified products are already in the system.",
            hardDeleteWarning: "Attention! Marked products will be completely removed from the system. Do you approve?",
            productAmount: "Product Amount",
            productExpired: "Product expired",
            productImage: "Product picture",
            expired: "Expired",
            exportBarcode: "Also export unit or kg indicator",
            datePurchase: "Purchase date",
            pricePurchase: "Purchase price",
            manufacturerDate: "Date of manufacture",
            withoutExpirationDate: 'This date will be automatically displayed for products without an expiration date'
        },
        productPriceModify: {
            title: "Change prices",
            newDocument: "new document",
            prognosis: "Forecast of changes",
            difference: "Quantity difference",
            price: "Price",
            marja: "Marja",
            newPrice: "New price",
            oldPrice: "Old price"
        },
        productPurchase: {
            title: "Product purchase",
            few: "Purchase few",
            pricePerUnit: "Price per {name}",
            alertAmount: "Reminder amount",
            debtAmount: "Loan amount",
            reminder: "Reminder",
            todayPurchasesAmount: "Today's purchase amount: ",
            price: "Purchase price",
            paymentAmount: "Payment amount",
            paymentHistory: 'Payment history',
            paymentDate: 'Payment date'
        },
        productsInWarehouse: {
            title: "Products in warehouses",
            writeOffDescription: "Enter the reason for the write off",
            writeOff: "Write off",
            wroteOff: "Written off products",
            reason: "Reason",
            changeWarehouse: "Move products in warehouse",
            changingProductsAmount: "{amount} products",
            deleteIsNotify: "Want to remove this product from the warning window?"
        },
        promoNew: {
            forWhom: 'For Whom',
            bureaucracy: {
                title: 'Are you tired of bureaucracy?',
                text: 'Manage your product with Boshqar!',
                anywhere: 'Anywhere',
                anyDevice: 'In any device',
                robbery: 'Prevention of theft and transparent process',
                only: 'Only for',
                perMonth: '/ month',
                test: 'Try to use',
                howItWorks: 'How it works?',
            },
            forAllBusiness: {
                title: 'Fits for any business',
                text: 'Boshqar is able to adapt to any task, regardless of size of business or enterprise.',
                supermarket: 'Supermarkets',
                pharmacy: 'Pharmacies',
                perfumery: 'Perfumery',
                plumbing: 'Plumbing',
                foodStore: 'Food stores',
                clothingStore: 'Clothing stores',
                constructionStore: 'Construction goods',
                variousBusiness: 'Different business types'
            },
            sale: {
                sale: 'SALE',
                title: 'The best opportunities for trading',
                text: {
                    sellProduct: 'Sale your products in sale page',
                    accountOnDept: 'Calculation of trade on debt',
                    saleStatistics: 'Getting the detailed statistics about purchase and sale'
                },
            },
            product: {
                product: 'PRODUCTS',
                title: 'Free and convenient goods management',
                text: 'The application allows you to manage goods. Specify the cost of the goods, the date of purchase or sale, and Boshqar system shows the balance in warehouses, revenue and other analytical information automatically.',
                analytics: {
                    analytics: 'Analytics',
                    analyticsText: 'The system of built-in reporting helps to identify critical points in the trade, popular and less sold products, and determine the acceptable level of discounts.',
                },
                finance: {
                    finance: 'Finance',
                    financeText: 'Financial statistics allows to track accurately the cost of each product, each position, any type of client debt.',
                },
                storeText: 'Create different warehouses for any type of sales, goods and different companies.',
                marketing: {
                    marketing: 'Marketing',
                    marketingText: 'Services of Boshqar allow more automated evaluation and tracking of the success services provided, both for trade and particular product.'
                },
            },
            observe: {
                observe: 'OBSERVATION',
                title: 'Manage your business from any point of the world',
                text: 'By installing Boshqar mobile application, the management, tracking and adjustment of trading process becomes more flexible.',
                checkCalculation: 'Checking of reports on sales, deliveries and purchases',
                checkRemainder: 'balance management of products',
                addTransaction: 'Control of transactions'
            },
            customer: {
                customer: 'CLIENTSS',
                title: 'Being in the same system with clients',
                text: 'Add clients to the system, specify them when making a deal. It is possible to add individuals or legal entities.'
            },
            transaction: {
                transactions: 'TRANSACTIONS',
                title: 'All transactions in one place',
                text: 'Check, control and analyze every sale and purchase transaction, as well as transactions in debt.',
            },
            employee: {
                employees: 'EMPLOYEES AND ROLES',
                title: 'Add all your employees to the system and assign roles to them',
                text: 'Add each of your employees to Boshqar system to manage trade. Assign them roles and access levels for more flexible work with staff.',
            },
            security: {
                security: 'SECURITY',
                title: 'The most important: no theft is allowed',
                text: 'Full control over each transaction ensures complete transparency in the trade of each product and the actions of employees. No distorted numbers.',
            },
            tariff: {
                paymentTerm: 'Subscription type',
                smallBusiness: 'For small business',
                middleBusiness: 'For middle Business',
                bigBusiness: 'For big business'
            },
            comingSoon: {
                mainText: 'Coming Soon: New business solutions',
                internetStore: 'INTERNET-STORE',
                taxServices: 'TAX ACCOUNTING',
                discounts: 'MORE SALES',
                otherServices: 'MORE OTHER SERVICES'
            },
            gratitude: 'Automated and universal service Boshqar with many years of experience of the development team is the best solution for any business of trade.'
        },
        role: {
            ROLE_SELLER: "Can sell",
            ROLE_STOREKEEPER: "Store manage stores",
            ROLE_PRODUCT_PURCHASER: "Can purchase products",
            ROLE_PRODUCT_MANAGER: "Can manage products ",
            ROLE_PRODUCT_PURCHASE_HISTORY: "Can see products purchase history",
            ROLE_SALE_HISTORY: "Can see sale history",
            ROLE_CUSTOMER_MANAGER: "Can manage customers",
            ROLE_EMPLOYEE_MANAGER: "Can manage employees",
            ROLE_SEE_CUSTOMER_DEBTS: "Can see debts",
            ROLE_SUPPLIER_MANAGER: "Can manage suppliers",
            ROLE_SERVICE_MANAGER: "Can manage services",
            ROLE_SEE_SUPPLIER_DEBTS: "Can see debts",
            ROLE_CAN_DELETE_SALE_HISTORY: "Can delete sales history",
            ROLE_DISCOUNT_MANAGER: "Can manage discounts",
            ROLE_KPI_MANAGER: "Can manage KPI",
            ROLE_INVENTORY_MANAGER: "Can manage inventory",
            ROLE_TAXES_MANAGER: "Can manage tax",
            ROLE_AUTOORDER_MANAGER: "Can make auto order"
        },
        returnProducts: {
            deficitQuantity: "Deficit quantity",
            return: "Return",
            returnAmount: "Return amount",
            returnDate: "Return date",
            returnSupplier: "Return Supplier",
            returnCustomer: "Return Customer",
            newReturn: "New return",
            returnSum: "Refund sum",
            saleDate: "Sale date",
            totalSum: "Total sum",
            totalResidue: "Total residue",
            type: "type",
            typeProduct: "type product",
        },
        sale: {
            editSaleWarning: "Attention!  This transaction will be duplicated, and the current will be cancelled. Do you confirm?",
            deleteSaleWarning: "Attention! This transaction will be completely deleted from the system. Do you confirm?",
            draft: "Draft",
            title: "Sale",
            todayTradeAmount: "Today's trade amount: ",
            newSale: "New sale",
            thankPurchase: 'Thank you for your purchase',
            sum: "Sum",
            seller: "Seller",
            totalSum: 'Total price',
            integration: "Integration with tax",
            integrationWarningCantSend: "Only products that available in the UNIFIED ELECTRONIC NATIONAL CATALOG can be sent to the tax office. None of the following products contain ICPS. These products cannot be integrated with tax. Continue?",
            integrationWarningCanSend: "Only products that available in the UNIFIED ELECTRONIC NATIONAL CATALOG can be sent to the tax office. ICPS for the following products is not available. They will not appear on the check.",
            confirmed: "Confirm",
            information: "Information about sale",
            confirm: "Do you confirm?",
            integrationTitle: "When this option is enabled, every sold product will be automatically tax-integrated.",
            finalSum: 'Final price',
            purchaseHistory: "Purchase history",
            cash: 'Cash',
            oddMoney: 'Odd Money',
            notEnoughPayed: "Payment amount is not enough (trading on credit?)",
            saleSum: 'Trade amount',
            tax: {
                inPrice: 'Tax is included in product price',
                onPrice: 'Tax on product price',
                withoutTax: 'Tax free',
                inPriceOnCheck: 'Including ',
                title: "Tax",
                name: 'Tax name'
            },
            discount: {
                title: "Discount",
                make: "Make a discount",
                startDate: 'Start time',
                endDate: 'End time',
                discountName: 'Discount Name',
                discountCondition: 'Discount condition',
                conditionsForDiscountingProducts: 'Conditions for discount',
                forAllProducts: 'For all products',
                forSomeProducts: 'For some products',
                amountForDiscount: 'Amount of money for discount',
                minimalSum: 'Minimum amount',
                discountDays: 'Discount days',
                discountParticipants: 'Discount participants',
                forAllCustomers: 'All customers',
                forSomeCustomers: 'Some customers',
                discountBonus: 'Discount bonus',
                customersGet: 'What customers get',
                discountSum: 'Amount discount',
                discountPercent: 'Percentage discount',
                discountProduct: 'Product as gift',
                discountType: 'Discount type',
                percentAmount: 'Amount of percent',
                sumAmount: 'Amount of money',
                forTotalSum: 'For the total amount',
                forProduct: 'For product',
                aboutDiscount: 'Information about discount'
            },
            product: {
                title: "Products",
            },
            transaction: {
                cancel: "Cancel",
                canceled: "Canceled"
            }
        },
        production: {
            title: 'Production',
            productPreparation: 'Product preparation',
            selectFile: "Select the file here",
            selectMaterial: 'Select the raw material',
            lossAddition: 'Losses or addition',
            margin: 'Margin',
            totalAmount: 'Total amount',
            composition: 'Composition',
            afterCleaning: 'After cleaning',
            cost: 'Cost price',
            additionalOutputs: 'Additional outputs',
            properties: {
                title: 'Properties',
                bestBefore: 'Best before',
                addLossTitle: "Enter new loss name",
                lossName: "Loss name",
                enterLossName: "Enter loss name"
            },
            finishedProduct: {
                title: 'Finished product',
                methodPreparation: 'Method of preparation'
            },
            category: {
                title: 'Category'
            },
            discount: {
                title: 'Discount'
            },
            transactions: {
                title: 'Transactions'
            }


        },
        scale: {
            title: 'Scales',
            name: 'Name of scale',
            scaleProduct: 'Weigher product',
            token: 'Token'
        },
        service: {
            title: "Service",
            services: "Services",
            serviceName: "Service name",
            addService: "Add service",
            price: "Price",
            servicePrice: "Service price",
            addedServices: "services have been added"
        },
        supplier: {
            choose: "Choose supplier",
            title: "Supplier",
            add: "Add supplier",
            type: "Type",
            hasDebts: "We owe this supplier",
            info: "Supplier information",
            deleteSupplierWarning: "Attention! This Supplier will be completely removed from the system. Can you confirm?",
            ourTotalDebt: "Our total debt"
        },
        soon: {
            title: "Soon",
            description: "Soon...",
        },
        statistics: {
            categories: {
                soldProducts: 'Sale of products',
                ourDebt: 'Our debt',
                profit: 'Net profit',
                debtor: 'Owe Us',
                totalSale: 'Total sale',
                cash: 'Cash',
                debt: 'Debt',
                bankCard: "Bank card",
                moneyTransfer: "Money transfer",
                employees: "By employees"
            },
            employee: {
                employee: 'Employee',
                activity: 'Activity',
                sum: 'Sum',
                avgReceipt: 'Average receipt',
                receiptCount: 'Amount of receipt',
                income: 'Income'
            },
            byPercent: 'By percentage',
            byAmount: 'By amount',
            byIncome: 'By income',
            income: 'Income',
            payTypes: "Payment methods",
            sale: 'Statistics of sale',
            service: 'Statistics of service',
            product: 'Statistics of product',
            productDynamic: 'Dynamics of product',
            period: 'Period',
            purchase: 'Statistics of purchase',
            customer: {
                title: 'Statistics of customer',
                purchaseAmount: 'Purchase amount',
                paymentMethod: 'Payment type',
                list: 'List of customers',
                amount: 'Amount',
                sum: 'Sum'
            },
            employeeStat: 'Statistics of employees',
            supplier: 'Statistics of suppliers',
            info: {
                sale: 'there no sales for selected period',
                debt: 'there no debts for selected period',
                gap: 'Between the sale and the appearance of the Products in the statistics - there is an interval of 5 minutes.'
            },
            weekday: {
                sun: 'Sunday',
                mon: 'Monday',
                tue: 'Tuesday',
                wed: 'Wednesday',
                thu: 'Thursday',
                fri: 'Friday',
                sat: 'Saturday'
            },
            weekdays: [
                'Sun',
                'Mon',
                'Tu',
                'Wed',
                'Thi',
                'Fri',
                'Sat'
            ],
            month: {
                Jan: 'January',
                Feb: 'February',
                Mar: 'March',
                Apr: 'April',
                May: 'May',
                Jun: 'June',
                Jul: 'July',
                Aug: 'August',
                Sep: 'September',
                Oct: 'October',
                Nov: 'November',
                Dec: 'December',
            },
            title: "Statistics",
            type: {
                statByDay: 'Daily',
                statByMonth: 'Monthly',
                statByYear: 'Annual',
                hourly: 'By hours',
                daily: 'By days',
                weekly: 'By weeks',
                monthly: 'By months',
            },
            xaxis: {
                hour: 'Hours',
                day: 'Days',
                month: 'Month',
                year: 'Year',
            },
            yaxis: 'Sum',
        },
        unitOfMeasure: {
            additionalUnitOfMeasurement: "An additional unit of measurement",
            comparison: "Comparison",
            short: "U. Of Meas",
            choose: "Choose the unit of measure",
            unitOfMeasure: "Unit of measure",

            // weight
            g: "g",
            kg: "kg",

            // liquid
            ml: "mL",
            l: "L",

            // length
            mm: "mm",
            cm: "cm",
            m: "m",
            km: "km",
            ft: "ft",

            // cubic meter
            m3: "㎥",

            // pic
            pc: "pc",
        },
        user: {
            email: "Email",
            emailForResetPassword: "Enter your email address and, we will send you a link to reset your password.",
            emailSent: "An email has been sent that contains a link that you can click to reset your password. This link will expire in 1 hour.\n If you don't receive an email please check your spam folder or",
            emailSentToEmployee: "A link was sent to the email of employee to set a login password. This link will expire in 1 hour",
            tryAgain: "try again",
            send: "Send",
            password: "Password",
            newPassword: "New password",
            repeatPassword: "Confirm password",
            resetPassword: "Reset password",
            forgotPassword: "Forgot your password?",
            passwordChanged: "Your password is successfully changed",
            resetTokenExpired: "this link has expired or already used,",
            errors: {
                emailExists: "This email is already exists",
            },
        },
        validator: {
            required: "Required",
            choose: "Choose",
            type: {
                int: "Should be integer",
                number: "Should be number",
                date: "Wrong date entered",
                email: "Enter valid email",
                strongPassword: "Password must contain letters, numbers and must be at least 8 characters in length",
                phone: "Enter valid phone number",
                notEnoughProductsInWarehouse: "Not enough products in warehouse",
                thirteenDigit: "Enter a 13-digit number",
                amount: "Wrong amount entered"
            },
        },
        warehouse: {
            title: "Warehouse",
            add: "Add warehouse",
            name: "Warehouse name",
            deleteWarning: "There are products in the warehouse that are being deleted. Please move the products to another warehouse!",
            choose: "Choose warehouse",
            remainder: "remainder",
            amountSalePrice: "The amount of the sale price",
            amountPurchasePrice: "The amount of the purchase price",
            TotalAmountProducts: "Total number of products",
            residueInWarehouse: 'Residue in warehouse'
        },
    },
    ru: {
        actions: "Действия",
        active: "активный",
        add: "Добавить",
        addDebt: "Добавить долг",
        debtPayingTime: "Дата выплаты долга",
        debtPayingTimeNotCome: "Дата выплаты долга еще не наступила",
        debtPayingTimeCome: "Настал срок",
        debtPayingTimeGone: "Срок давности прошел",
        additional: "Дополнительно",
        additionalInformation: "Дополнительная информация",
        advice: "Совет",
        amount: "Количество",
        boughtPrice: "Цена покупки",
        beforeLeaveAdvice: 'Вы действительно хотите покинуть страницу? У вас есть несохраненные изменения!',
        cancel: "Отмена",
        category: "Категория",
        collapseSidebar: "Свернуть панель",
        connectionRefused: "Нет связи с сервером",
        currency: "Валюта",
        createdAt: "Дата создания",
        date: "Дата",
        debt: "Долг",
        debtAmount: "Сумма долга",
        delete: "Удалить",
        download: 'Скачать',
        cancelDelete: "Не удалять",
        deleteConfirm: "Уверены что хотите удалить \"{name}\"?",
        deleteConfirmSimple: "Вы уверены, что хотите удалить?",
        detailed: "Подробный",
        edit: "Изменить",
        errorData: "Ошибка",
        errorDate: "Введена неверная дата",
        empty: "Пусто",
        export: "Создать файл для весов",
        goBack: "Назад",
        hasPayed: "Оплачено?",
        home: "Главная",
        id: "Ид.",
        loginSystem: "Войти в систему",
        main: "Важное",
        more: "Еще",
        moreInfo: "Больше деталей",
        move: "Переместить",
        name: "Название",
        new: "Новое",
        no: "Нет",
        noData: "Нет данных",
        notInfo: "Информация, которую вы искали, не найдена",
        ok: "Ок",
        onCredit: "В долг",
        overPayed: "Сумма превышает сумму долга",
        pay: "Оплатить",
        payed: "Оплачено",
        payedAmount: "Cумма платежа",
        payType: "Способ оплаты",
        payDebt: "Оплатить долг",
        payWarning: "Внимание! Вы действительно хотите заплатить следующую сумму?",
        purchase: "Купить",
        purchasePerUnit: "Цена покупки ",
        profile: 'Профиль',
        price: "Цена",
        pcs: 'шт',
        print: "Печать",
        refresh: "Обновить",
        refreshInfo: "Информация обновляется...",
        search: "Поиск",
        save: "Сохранить",
        select: "Выберите",
        selected: "Выбрано",
        selectError: "Извините, подходящих вариантов нет",
        sellingPrice: "Цена продажи",
        saved: "Сохранено",
        technicalWorks: "Ведутся технические работы с целью улучшения качества обслуживания",
        total: "Итого",
        totalBalance: "Итоговый баланс",
        totalSalesAmount: 'Общая сумма покупки',
        totalPrice: "Общая цена",
        transactions: "Транзакции",
        trash: "Удаленные товары",
        treeView: "В виде дерева",
        unknownError: 'Неизвестная ошибка :(',
        view: "Просмотр",
        warning: "Внимание",
        yes: "Да",
        year: "Год",
        loss: 'Потеря',
        atWork: {
            atWork: "На работе",
            againEntry: "Вы хотите войти снова",
            againEntryReason: "Причина повторного входа",
            cantEntry: "Существует ограничение на повторное использование системы",
            limit: "Разрешенное количество входов: 3 раза",
            closeNow: "Закрыть сейчас",
            currentTime: "Текущая время",
            confirmFinishWork: "Одобряете ли вы уход с работы раньше?",
            ended: "Закончил работу",
            yourJobTime: "Ваше рабочее время",
            greeting: "Здраствуйте!",
            startJob: "Начать работу",
            started: "Началь работу",
            today: "Сегодня",
            toJobTime: "До начала рабочего время",
            title: "На работе",
            late: "Вы опаздали на работу",
            lateTime: "Время опаздования",
            reasonLate: "Причина опаздования",
            minSymbolAmount: "Введите не менее 10 символов",
            hour: "час",
            minute: "минут",
            jobTime: "Рабочее время",
            from: "от",
            to: "к",
            reason: "Причина",
            finishWork: "Завершение работы",
            wantFinishWorkBeforeTime: "Рабочая время ещё не окончено. Хотите уйти?",
        },
        autoOrder: {
            title: "Автозаказ",
            modalTitle: "Даты автозаказа",
            orderDate: 'Датa автозаказа',
            lastOrderPeriod: 'Период последнего автозаказа',
            lastOrderDate: 'Дата последнего автозаказа',
            order: 'Заказ',
            new: 'Новый автозаказ',
            daily: '(дня) дней',
            period: 'Период заказа',
            amount: 'Количество заказа',
            sum: 'Сумма заказа',
            sold: 'Продано',
            soldOutDate: 'Дата окончания',
            status: 'Статус заказа',
            marja: 'Рентабельность',
            prepared: 'Заказ подготовлен',
            saleRate: 'Количество продажи',
            avgSaleRate: 'Продажи/день',
            productPriceSum: 'Сумма продуктов (по цене последней покупки)',
            makeOrder: 'Заказать',
            ordered: 'Заказано',
            excelFileForPurchase: 'Excel файл для покупки',
            noSale: 'Нет продаж за выбранный период',
            noNeedOrder: 'Заказ не нужен'
        },
        order: {
            onlineOrder: 'Онлайн заказ'
        },
        debtor: {
            debtSuccessPaid: "Долг был успешно погашен",
            indebtedness: "Задолженность"
        },
        error: {
            purchaseCancel: "Часть товаров уже продана",
            access: "У вас нет прав на это действие",
            overLimit: "Вы не можете добавить больше, чем разрешено вашим планом подписки."
        },
        company: {
            owner: "Владелец компании",
            accessTime: 'Компания активна до {date}',
            activePeriod: 'Aктивность компании',
            create: "Регистрация",
            registeredDate: "Дата регистрации",
            employeesCount: "Количество работников",
            name: "Название компании",
            telephone: "Номер телефона",
            namePlaceholder: "Магазин",
            title: "Компания",
            remaining: {
                productsPrice: "Товары на сумму",
                hasMoney: "Деньги",
                ourDebt: "Мы должны",
                oweUs: "Должны нам",
            },
            managerId: "Идентификационный номер менеджера",
            managerError: "Менежер под этим номером не существует",
            month: {
                Jan: 'Января',
                Feb: 'Февраля',
                Mar: 'Марта',
                Apr: 'Апреля',
                May: 'Мая',
                Jun: 'Июня',
                Jul: 'Июля',
                Aug: 'Августа',
                Sep: 'Сентября',
                Oct: 'Октября',
                Nov: 'Ноября',
                Dec: 'Декабря',
            },
        },
        companyRequisites: {
            baseCurrency: "Выберите основную валюту",
            tin: "ИНН",
            gceo: "ОКПО",
            legalAddress: "Юридический адрес",
            physicalAddress: "Физический адрес",
            chiefDirector: "Генеральный директор",
            addTin: "Добавьте ИНН",
            addGceo: "Добавьте ОКПО",
            addLegalAddress: "Добавьте юридический адрес",
            addPhysicalAddress: "Добавьте физический адрес",
            addChiefDirector: "Добавьте имя генерального директора",
            moneyInWallet: "Введите имеющийся сумму денег"
        },
        customer: {
            choose: "Выберите клиента",
            customers: "Клиенты",
            canDeleteSaleWarning: "Внимание! Этому сотруднику дано право удалять всю торговую историю",
            title: "Клиенты",
            numberOfCustomers: "Количество клиентов",
            numberOfDebtors: "Количество должников",
            purchase: "Покупка",
            add: "Добавить клиента",
            averageCheck: "Средний чек",
            dateAdd: "Дата добавлена",
            debtors: "Должники",
            cashback: {
                title: "кешбэк",
                amount: "Сумма кэшбэка",
                notHaveCashback: "У этого клиента нет кэшбэка!",
                notHaveCashbackCard: "У этого клиента нет кэшбэк-карты!",
                residue: "Остаточный кэшбэк",
                payFromCashback: "Оплата с кэшбэком",
                numberNotAvailable: "Этот номер недоступен. Пожалуйста, введите другой номер.",
                totalAmount: "Общая сумма кэшбэка"
            },
            type: "Тип",
            info: "Информация для покупателей",
            hasDebts: "У данного клиента имеются долги",
            notExist: "В данный момент этот клиент недоступен или удалено из системы",
            deleteAnyway: "Забыть о долгах и удалить",
            deleteCustomWarning: "Внимание! Этот Клиент будет полностью удален из системы. Можете подтвердить?",
            personalInformation: "Личный информация",
            loyaltyCard: "Дисконтная карта",
            bankAccountNum: "Номер банковского счета",
            createdAtCompany: "Дата создания компания",
            webSite: "Веб-сайт",
            scoreAndDiscount: "Набирайте баллы и делайте скидки",
            score: "Баллы",
            discount: "Скидка",
            factAddress: "Адрес факта",
            firstPurchase: "Дата первой покупки",
            opportunities: "Возможности",
            discountPercent: "Процентная скидка",
            totalSalesAmount: "Общая сумма продаж",
            discounted: "Сделать скидку",
            discountAmount: "Сумма скидки",
        },
        currencyRate: {
            choose: "Выберите валюту",
            centralBankRate: 'Курс центрального банка',
            change: 'Изменение',
            companyRate: 'Введите курсы валют компании:',
            currencyRate: 'Курсы валюты',
            currencyName: 'Наименования валют',
            officialRate: 'Официальный курс центрального банка на текущую дату: ',
            ourRate: 'Наш курс:',
            rate: 'Курс',
            rub: 'Российский рубль',
            saveRate: 'Сохранить курс',
            uzs: 'Узбекский сум',
            symbol: 'Символ',
            usd: 'доллар США',
            sum: 'сум'
        },
        supplier: {
            choose: "Выберите поставщик",
            title: "Поставщик",
            add: "Добавить поставщик",
            type: "Тип",
            hasDebts: "Мы должны этому поставщику",
            info: "Информация о поставщике",
            deleteSupplierWarning: "Внимание! Этот Поставщик будет полностью удален из системы. Можете подтвердить?",
            ourTotalDebt: "Наш общий долг"

        },
        employee: {
            title: "Сотрудники",
            canAuth: "Может входить в систему",
            position: "Должность",
            cashier: "Кассир",
            workTimeAndSalary: "Рабочее время и зарплата",
            hiredDate: "Дата приема на работу. (день/месяц/год)",
            personalInformation: "Личная информация",
            belongToApp: "Касательно к системе",
            telegram: "Телеграм",
            jobEndTime: "На часах осталось {time} минут!",
            jobType: {
                title: "Порядок работы",
                hourly: "Часовой",
                daily: "Дневной",
                weekly: "Неделной",
                monthly: "Месячный"
            },
            jobSchedule: {
                title: "График работы"
            },
            salary: "Зарплата",
            wasBornDay: "Дата рождения:",
            workTimeFrom: "Время работы (с)",
            workTimeTo: "Время работы (до)"
        },
        excel: {
            row: 'ряд',
            import: "Импортировать",
            importAgain: "Импортировать снова",
            notImport: "Не импортировать",
            selectEachColumn: 'Выберите функцию каждого столбца',
            choiceExcelFile: 'Выберите файл Excel',
            importedFile: "В базу внесено {lines} строки данных",
            checkData: "Отправлена неверная информация",
            hasEmptyFields: "Имеет пустые поля",
            validExcel: 'Пожалуйста, загрузите правильный Excel',
            saleCurrency: "Валюта продажи",
            purchaseCurrency: "Валюта покупки",
        },
        expirationProduct: {
            soldOut: "Распроданный",
            notSold: "Не продано",
            expiredProductsTotalAmount: "Количество просроченных Товаров:",
            productsFiveDaysLeftExpire: "Количество товаров, срок действия которых истекает через 5 дней:",
            productsTenDaysLeftExpire: "Количество товаров, срок действия которых истекает за 10 дней:",
        },
        filter: {
            all: "Все",
            clear: "Очистить ",
            filters: "Фильтры",
            fromAmount: "Количество от",
            fromPrice: "Цена от",
            fromDateToDate: "Год-месяц-число",
            fromSellingPrice: "Цена продажи от",
            fromSum: "Суммы от",
            thisDay: "С этого (год-месяц-число)",
            thisTime: "С этого число...",
            toAmount: "Количество до",
            toPrice: "Цена до",
            toSellingPrice: "Цена продажи до",
            toTime: "До этого число...",
            toDay: "До этого (год-месяц-число)",
            toSum: "Суммы до ",
        },
        finance: {
            financialSituation: "Финансовая ситуация",
            balance: "Баланс",
            title: "Финансы",
            counts: "Счет",
            count: "Счет",
            report: "Отчет",
            fromCount: "Со счета",
            whichCount: "На счет",
            newCount: "Новый счет",
            initialAmount: "Первоначальная сумма",
            deleteInfo: "Категория успешно удалена!",
            deleteCountInfo: "Счет успешно удалена!",
            transfer: "Перечислить",
            income: {
                sale: "Прадажа",
                purchase: "Пакупка",
                rent: "Аренда",
                salary: "Зарплата",
                communal: "Коммунальная",
                debt: "Заем",
                credit: "Кредитование",
                paymentSystem: "Оплата за систему",
            }
        },
        image: {
            title: "Изображения",
            choiceImageFile: 'Выберите Изображения',
            validImage: 'Пожалуйста, загрузите правильный Изображения'
        },
        import: {
            advice: 'Чтобы импортировать товары воспользуйтесь <router-link to="https://boshqar.com/" target="_blank">компьютерной версии</router-link>',
        },
        incomeAndOutcome: {
            allIncome: "Весь доход",
            allOutlay: "Весь расход",
            title: "Доход / Расход",
            income: "Доход",
            outlay: "Расход",
            Status: "Статус",
        },
        inventory: {
            advice: 'Чтобы инвентировать товары воспользуйтесь <router-link to="https://boshqar.com/" target="_blank">компьютерной версии</router-link>',
            title: "Инвентаризация",
            result: "Результат",
            difference: "Разница",
            sumDifference: "Разница в сумме",
            deficit: "Недостаточно",
            profit: "Избыточно",
            amount: "Остаток в системе",
            realAmount: "Истинный остаток",
            allProducts: "Все продукты",
            fitProducts: "Подходящие продукты",
            nonFitProducts: "Продукты, которые имеют разницу",
            profitProducts: "Лишние продукты",
            deficitProducts: "Недостающие продукты",
            finance: "Финансы",
            responsiblePerson: "Ответственный человек",
            sumSelectedProducts: "Сумма выбранных продуктов",
            sumFitProducts: "Количество совподающих продуктов",
            sumProfitProducts: "Количество лишных продуктов",
            sumDeficitProducts: "Количество недостающих продуктов",
            sumDifferenceProducts: "Сумма несовподающих продуктов",
            syncing: "Синхронизация...",
            synced: "Синхронизировано",
            sync: "Синхронизировать"
        },
        kpi: {
            title: "КПИ",
            type: "Тип КПИ",
            condition: "Условия КПИ",
            conditionIssue: "Условия выдачи КПИ",
            forAllProducts: "Для всех товаров",
            forSomeProducts: "Для некоторых товаров",
            forExactProduct: "Для одного товара",
            finish: "Заканчивать",
            products: "Товары",
            sum: "План КПИ",
            salePlan: "План продаж",
            saleSum: "Сумма продаж",
            status: "Статус",
            period: {
                title: "Период",
                daily: "Дневной",
                weekly: "Недельный",
                monthly: "Месячьный"
            },
            onlyActives: "Только активные",
            plan: "КПИ/План",
            planDone: "План был выполнен",
            done: "Сделано",
            indicatorOfEmployees: "Показатель эффективности работы сотрудников",
            date: {
                title: "Дата",
                startDate: "Дата начала",
                endDate: "Дата окончания"
            },
            daysOfKpi: "Дни КПИ",
            participants: "участники КПИ",
            forAllEmployees: "Всем сотрудникам",
            forSomeEmployees: "Некоторым сотрудникам",
            employees: "Сотрудники",
            bonus: {
                title: "Бонус",
                forEmployee: "Что получает сотрудник?",
                onSum: "Бонус в сумме",
                fromIncome: "Проценты от прибыли",
                product: "Товар",
                percentAmount: "Процент",
                bonusAmount: "Сумма бонуса",
                given: "Дано",
                give: "Давать",
                received: "Получен",
                notReceived: "Не получено"
            },
            employee: {
                title: "Сотрудник Ф.И.О",
            },
            salary: {
                mainTitle: "Зарплата/Платежи",
                salary: "Зарплата",
                income: "Доход",
                title: "Зарплата",
                payForNewMonth: "Заплатить за новый месяц",
                forNewMonth: "За новый месяц",
                forWhatMonth: "За какой месяц",
                fromWhichCount: "С какого счета должна быть произведена оплата?",
                payedAmount: "К оплате",
                payed: "Оплачено",
                pay: "Оплата",
                historyOfPay: "История платежей",
                totalPayed: "Итого выплаченная зарплата",
                more: "ещё",
                payDate: "Дата оплаты",
            },
        },
        login: {
            title: "Войти",
            logout: "Выйти",
            success: 'Привет, {login}!',
            error: 'Неправильный email, или пароль',
            bye: 'Пока...',
        },
        notActive: "не активный",
        person: {
            title: "Человек",
            additionalName: "Отчество",
            age: "лет",
            contacts: "Контакты",
            year: "год",
            givenName: "Имя",
            familyName: "Фамилия",
            birthday: "День рождения (день/месяц/год)",
            fullName: "ФИО",
            yourGivenName: "Ваша имя",
            yourFamilyName: "Ваша фамилия",
            otherInformation: "Дополнительное сведение",
            telephone: "Номер телефона",
            telegram: "Телеграм",
            gender: {
                title: "Пол",
                man: "Мужчина",
                woman: "Женщина",
            },
        },
        plan: {
            title: "Цены",
            compare: "Сравнение планов",
            hasExpired: "Необходимо продлить ваш план",
            mainTitle: "Ежемесячная плата за пользование системой определяется согласно тарифным планам.",
            subTitle: "Если вы хотите сэкономить 17%, мы рекомендуем платить за один год.",
            conditions: "Первые 7 дней использования системы бесплатны! В это время вы можете протестировать систему, не тратя денег. Программа работает на Премиум-плане в течение бесплатного периода.",
            statisticsTitle: "Ежедневно, ежемесячно, ежегодно. Ежедневный доход, топовые товары, какой товар продается в больших количествах, возможность удаленно отслеживать все сделки в графическом виде",
            statistics: "Статистика",
            employeesCount: "Количество сотрудников",
            warehousesCount: "Количество складов",
            suppliersCount: "Количество поставщиков",
            customersCount: "Количество клиентов",
            priceForMonth: "Цена за месяц",
            priceForYear: "Цена за год со скидкой 17%",
            unlimit: "неограниченный",
            feature: "Возможность",
            planChangeWarning: "Вы переходите план который возможности ниже чем ваш текуший план. В этом случае количество складов уменшается в соответствии с вашим планом, а осталное будет удалено. Товары из удаленных складов будут перемещены на существующие склады. Вы согласны продолжать?"
        },
        printView: {
            directorCompany: 'Директор',
            totalSum: 'Итоговая сумма',
            printA4: 'Распечатать накладной',
            printCheck: 'Распечатать чека',
            printEpos: 'Распечатать чек Epos',
            receipt: "Чек №",
            addInfo: "Дополнительная информация к чеку"
        },
        product: {
            title: "Товар",
            title2: "Товары",
            add: "Добавить товар",
            addMany: "Добавить несколько",
            name: "Название товара",
            choose: "Выберите товар",
            chooseAndAdd: "Выберите товар | Добавить",
            count: "Количество товаров",
            barcode: "Штрих код",
            formatBarcode: "введите не менее 7 цифр",
            hasExpirationDate: "Нет срока годности",
            expirationDate: "Срок годности",
            export: "Экспорт",
            restore: "Восстановить",
            restoreWarning: "Внимание! Выбранные товары будут восстановлены. Вы одобряете?",
            notRestored: "Невозможно восстановить, так как указанные товары уже есть в системе.",
            hardDeleteWarning: "Внимание! Отмеченные товары будут полностью удалены из системы. Вы одобряете?",
            productAmount: "Количество товара",
            productExpired: "Срок годности",
            productImage: "Изображение товара",
            expired: "Истекший срок",
            exportBarcode: "Также экспортировать показатель единицы или кг",
            datePurchase: "Дата покупки",
            pricePurchase: "Цена покупки",
            manufacturerDate: "Дата производства",
            withoutExpirationDate: 'Эта дата будет автоматически отображаться для продуктов без срока годности.'
        },
        productPriceModify: {
            title: "Изменить цены",
            newDocument: "Новый документ",
            prognosis: "Прогноз изменений",
            difference: "Разница в количестве",
            price: "Цена",
            marja: "Маржа",
            newPrice: "Новая цена",
            oldPrice: "Старая цена"
        },
        productPurchase: {
            title: "Покупка товаров",
            few: "Покупать несколько",
            pricePerUnit: "Цена за {name}",
            alertAmount: "Оповещения",
            debtAmount: "Сумма долга",
            reminder: "Напоминание",
            price: "Цена покупки",
            todayPurchasesAmount: "Сумма покупки на сегодня: ",
            paymentAmount: "Сумма к оплате",
            paymentHistory: 'История платежей',
            paymentDate: 'Дата платежа'
        },
        productsInWarehouse: {
            title: "Товары на складах",
            writeOffDescription: "Введите причину списания",
            writeOff: "Списать",
            wroteOff: "Списанные товары",
            reason: "Причина",
            changeWarehouse: "Перемещение товаров склада",
            changingProductsAmount: "{amount} товаров",
            deleteIsNotify: "Хотите удалить этот товар из окна предупреждения?"
        },
        promoNew: {
            forWhom: 'Для кого',
            bureaucracy: {
                title: 'Устали от бюрократии?',
                text: 'Управляйте своим продуктом с помощью Boshqar!',
                anywhere: 'С любой точки земного шара',
                anyDevice: 'С любого устройства',
                robbery: 'Предотвращение краж и прозрачный процесс',
                only: 'Всего за',
                perMonth: '/ мес.',
                test: 'Попробовать',
                howItWorks: 'Как это работает?',
            },
            forAllBusiness: {
                title: 'Подходит для любого бизнеса',
                text: 'Boshqar способен адаптироваться под любые задачи, вне зависимости от размеров бизнеса и предприятия.',
                supermarket: 'Супермаркеты',
                pharmacy: 'Аптеки',
                perfumery: 'Парфюмерия',
                plumbing: 'Сантехники',
                foodStore: 'Продуктовые магазины',
                clothingStore: 'Магазины одежды',
                constructionStore: 'Строительные магазины',
                variousBusiness: 'Любой тип бизнеса'
            },
            sale: {
                sale: 'ППРОДАЖА',
                title: 'Самые лучшие возможности для торговли',
                text: {
                    sellProduct: 'Продавайте ваши товары в соответствующем разделе Продаж.',
                    accountOnDept: 'Расчёт торговли в долг.',
                    saleStatistics: 'Вывод детальной статистики о купле-продаже.'
                }
            },
            product: {
                product: 'ПРОДУКТЫ',
                title: 'Лёгкое и удобное управление товарами',
                text: 'Приложение позволит управлять товарами. Укажите стоимость товаров, дату покупки или продажи и система Boshqar покажет остаток на складах, выручку и другую аналитическую информацию.',
                analytics: {
                    analytics: 'Аналитика',
                    analyticsText: 'Система встроенных отчётов поможет определить критические точки в торговле, определить популярные и менее продаваемые товары, определить допустимый уровень скидок.',
                },
                finance: {
                    finance: 'Финансы',
                    financeText: 'Статистика по финансам позволит точечно отслеживать стоимость каждого товара, каждой позиции, любые типы клиентской задолженности.',
                },
                storeText: 'Создавайте разные склады под любые типы продаж, товаров и разные компании.',
                marketing: {
                    marketing: 'Маркетинг',
                    marketingText: 'Сервисы Boshqar позволят более автоматизировано оценивать и отслеживать успешность предоставляемых услуг, как по торговле, так и по отдельному товару.'
                },
            },
            observe: {
                observe: 'ПОЛЕЗНО ЗНАТЬ',
                title: 'Управляйте своим бизнесом из любой точки мира',
                text: 'Установив мобильное приложение Boshqar, управление, отслеживание и корректировка процесса торговли станет более гибким.',
                checkCalculation: 'Сверка отчётов о продажах, поставках и покупке',
                checkRemainder: 'Управление балансом товаров',
                addTransaction: 'Контроль над транзакциями'
            },
            customer: {
                customer: 'КЛИЕНТЫ',
                title: 'Быть в одной волне с клиентами',
                text: 'Добавляйте клиентов в систему, указывайте их при совершении сделки. Добавлять можно как физических лиц, так и юридических.'
            },
            transaction: {
                transactions: 'ТРАНЗАКЦИИ',
                title: 'Все транзакции в едином месте',
                text: 'Просматривайте, контролируйте и анализируйте каждую транзакцию по купле-продаже, а также сделки, совершённые в долг.',
            },
            employee: {
                employees: 'СОТРУДНИКИ И РОЛИ',
                title: 'Добавляйте в систему всех своих сотрудников и назначайте им роли',
                text: 'Добавляйте каждого своего сотрудника в систему Boshqar, для управления торговлей. Назначайте им роли и уровень доступа, для более гибкой работы с персоналом.',
            },
            security: {
                security: 'ЗАЩИТА',
                title: 'Важно! Защита от кражи и обмана',
                text: 'Полный контроль над каждой транзакцией обеспечит полную прозрачность в движении каждого товара и действий сотрудников. Никаких искажённых цифр.',
            },
            tariff: {
                paymentTerm: 'Тип подписки',
                smallBusiness: 'Для малого бизнеса',
                middleBusiness: 'Для среднего бизнеса',
                bigBusiness: 'Для крупного бизнеса'
            },
            comingSoon: {
                mainText: 'Скоро: Новые решения для Бизнеса',
                internetStore: 'ИНТЕРНЕТ-МАГАЗИН',
                taxServices: 'УЧЁТ НАЛОГОВ',
                discounts: 'БОЛЬШЕ СКИДОК',
                otherServices: 'БОЛЬШЕ ДРУГИХ УСЛУГ'
            },
            gratitude: 'Автоматизированный и универсальный сервис Boshqar с многолетним опытом команды разработчиков - лучшее решение для любого бизнеса в торговле.'
        },
        role: {
            ROLE_SELLER: "Может продавать",
            ROLE_STOREKEEPER: "Может управлять складом",
            ROLE_PRODUCT_PURCHASER: "Может покупать товары",
            ROLE_PRODUCT_MANAGER: "Может управлять товарами",
            ROLE_PRODUCT_PURCHASE_HISTORY: "Может посмотреть историю покупок товаров",
            ROLE_SALE_HISTORY: "Может посмотреть историю продаж",
            ROLE_CUSTOMER_MANAGER: "Может управлять клиентами",
            ROLE_EMPLOYEE_MANAGER: "Может управлять сотрудниками",
            ROLE_SEE_CUSTOMER_DEBTS: "Может посмотреть долги",
            ROLE_SUPPLIER_MANAGER: "Может управлять поставщиками",
            ROLE_SERVICE_MANAGER: "Может управлять сервисами",
            ROLE_SEE_SUPPLIER_DEBTS: "Может посмотреть долги",
            ROLE_CAN_DELETE_SALE_HISTORY: "Может удалять историю продаж",
            ROLE_DISCOUNT_MANAGER: "Может управлять скидками",
            ROLE_KPI_MANAGER: "Может управлять КПИ",
            ROLE_INVENTORY_MANAGER: "Может управлять инвентаризацией",
            ROLE_TAXES_MANAGER: "Может управлять налогом",
            ROLE_AUTOORDER_MANAGER: "Может управлять авто. заказами"
        },
        returnProducts: {
            deficitQuantity: "Нехватка количества",
            return: "Возврат",
            returnAmount: "Количество возвратов",
            returnDate: "Дата возвращения",
            returnSupplier: "Возврат поставщику",
            returnCustomer: "Возврат от клиента",
            newReturn: "Новый возврат",
            returnSum: "Сумма возврата",
            saleDate: "Дата продажи",
            totalSum: "Общая сумма",
            totalResidue: "Итоговой остаток",
            type: "тип",
            typeProduct: "Тип товара",

        },
        sale: {
            editSaleWarning: "Внимание! Данная транзакция будет дублирована, а текущая - отменена. Подтверждаете?",
            deleteSaleWarning: "Внимание! Данная транзакция полностью удалится из системы. Подтверждаете?",
            draft: "Черновик",
            title: "Продажа",
            todayTradeAmount: "Сегодняшняя сумма сделки: ",
            newSale: "Новая продажа",
            thankPurchase: 'Спасибо за покупку',
            sum: "Сумма",
            integration: "Интеграция с налогами",
            integrationWarningCantSend: "В налоговую инспекцию можно отправить только товары, имеющиеся в ЕДИНОМ ЭЛЕКТРОННОМ НАЦИОНАЛЬНОМ КАТАЛОГЕ. Ни один из следующих продуктов не содержит ИКПУ. Эти продукты не могут быть интегрированы с налогом. Продолжать?",
            integrationWarningCanSend: "В налоговую инспекцию можно отправить только товары, имеющиеся в ЕДИНОМ ЭЛЕКТРОННОМ НАЦИОНАЛЬНОМ КАТАЛОГЕ. ИКПУ для следующих продуктов недоступен. Они не появятся в чеке.",
            confirmed: "Подтверждать",
            information: "Информация о продажи",
            confirm: "Подтверждаете?",
            integrationTitle: "Когда этот параметр включен, каждый проданный продукт будет автоматически интегрирован с налогом",
            seller: "Продавец",
            purchaseHistory: "История покупки",
            cash: 'Наличные',
            oddMoney: 'Сдача',
            totalSum: 'Общая сумма',
            finalSum: 'Итоговая сумма',
            notEnoughPayed: "Сумма платежа недостаточна (торг в долг?)",
            saleSum: "Сумма сделки",
            tax: {
                inPrice: 'Налог включен в стоимость товара',
                onPrice: 'Налог на цену продукта',
                withoutTax: 'Без налогов',
                inPriceOnCheck: 'Включая ',
                title: "Налог",
                name: 'Название налога'
            },
            discount: {
                title: "Скидки",
                make: "Сделать скидку",
                startDate: 'Время начала',
                endDate: 'Время окончания',
                discountName: 'Название скидки',
                discountCondition: 'Условия скидки',
                conditionsForDiscountingProducts: 'Условия скидки',
                forAllProducts: 'Для всех товаров',
                forSomeProducts: 'Для некоторых товаров',
                amountForDiscount: 'Сумма денег для скидки',
                minimalSum: 'Минимальная сумма',
                discountDays: 'Скидочные дни',
                discountParticipants: 'Скидка участникам',
                forAllCustomers: 'Все клиенты',
                forSomeCustomers: 'Некоторые клиенты',
                discountBonus: 'Дисконтный бонус',
                customersGet: 'Что получают клиенты',
                discountSum: 'Сумма скидки',
                discountPercent: 'Процентная скидка',
                discountProduct: 'Товар в подарок',
                discountType: 'Тип скидки',
                percentAmount: 'Сумма процентов',
                sumAmount: 'Количество денег',
                forTotalSum: 'На общую сумму',
                forProduct: 'Для товара',
                aboutDiscount: 'Информация о скидке'
            },
            product: {
                title: "Товары",
            },
            transaction: {
                cancel: "Отмена",
                canceled: "Отменено"
            }
        },
        production: {
            title: 'Производство',
            productPreparation: 'Подготовка продукта',
            selectFile: 'Выберите файл отсюда',
            selectMaterial: 'Выберите сырье',
            lossAddition: 'Потери или прибавление',
            margin: 'Маржа',
            composition: 'состав',
            totalAmount: 'Общая сумма',
            afterCleaning: 'После очистки',
            cost: 'Себестоимость',
            additionalOutputs: 'Дополнительные расходы',
            properties: {
                title: 'Сырье',
                bestBefore: 'Употребить до: ',
                addLossTitle: "Введите название новой потери",
                lossName: "Название потери",
                enterLossName: "Введите название потери"
            },
            finishedProduct: {
                title: 'Готовый продукт',
                methodPreparation: 'Способ приготовления',
            },
            category: {
                title: 'Категория'
            },
            transactions: {
                title: 'Транзакции'
            }
        },
        scale: {
            title: 'Весы',
            name: 'Имя весы',
            scaleProduct: 'Весовой товар',
            token: 'Токен'
        },
        service: {
            title: "Услуги",
            services: "Услуги",
            serviceName: "Наименование услуги",
            addService: "Добавить услугу",
            price: "Цена",
            servicePrice: "Цена услуги",
            addedServices: "были добавлены услуги"
        },
        soon: {
            title: "Скоро",
            description: "Скоро...",
        },
        statistics: {
            categories: {
                soldProducts: 'Продажа товаров',
                ourDebt: 'Наш долг',
                profit: 'Чистая прибыль',
                debtor: 'Должны нам',
                totalSale: 'Общая продажа',
                cash: 'Наличные',
                debt: 'В долг',
                bankCard: "Банковская карта",
                moneyTransfer: "Перечисление",
                employees: "По сотрудникам"
            },
            employee: {
                employee: 'Сотрудник',
                activity: 'Активность',
                sum: 'Сумма',
                avgReceipt: 'Средний чек',
                receiptCount: 'Количество чеков',
                income: 'Прибыль'
            },
            byPercent: 'В процентах',
            byAmount: 'По количестве',
            byIncome: 'По доходам',
            income: 'Доход',
            payTypes: "Способы оплаты",
            sale: 'Статистика продаж',
            service: 'Статистика услуг',
            product: 'Статистика продукта',
            productDynamic: 'Динамика продукта',
            period: 'Период',
            purchase: 'Статистика покупки',
            customer: {
                title: 'Статистика клиента',
                purchaseAmount: 'Количество покупки',
                paymentMethod: 'Способ оплаты',
                list: 'Список клиентов',
                amount: 'Количество',
                sum: 'Сумма'
            },
            employeeStat: 'Статистика сотрудников',
            supplier: 'Статистика поставщиков',
            info: {
                sale: 'нет продаж за выбранный период',
                debt: 'нет долгов за выбранный период',
                gap: 'Между продажей и появлением Товара в статистике - существует интервал в 5 минут.'
            },
            weekday: {
                sun: 'Воскресенье',
                mon: 'Понедельник',
                tue: 'Вторник',
                wed: 'Среда',
                thu: 'Четверг',
                fri: 'Пятница',
                sat: 'Суббота'
            },
            weekdays: [
                'Воск',
                'Пн',
                'Вт',
                'Ср',
                'Чет',
                'Пят',
                'Суб'
            ],
            month: {
                Jan: 'Январь',
                Feb: 'Февраль',
                Mar: 'Март',
                Apr: 'Апрель',
                May: 'Май',
                Jun: 'Июнь',
                Jul: 'Июль',
                Aug: 'Август',
                Sep: 'Сентябрь',
                Oct: 'Октябрь',
                Nov: 'Ноябрь',
                Dec: 'Декабрь',
            },
            title: "Статистика",
            type: {
                statByDay: 'Дневной',
                statByMonth: 'Месячный',
                statByYear: 'Годовой',
                hourly: 'По часам',
                daily: 'По дням',
                weekly: 'По неделям',
                monthly: 'По месяцам',
            },
            xaxis: {
                hour: 'Часы',
                day: 'Дни',
                month: 'Месяцы',
                year: 'Год',
            },
            yaxis: 'Сумма',
        },
        unitOfMeasure: {
            additionalUnitOfMeasurement: "Дополнительная единица измерения",
            comparison: "Сравнение",
            short: "Ед. изм",
            choose: "Выберите единицу измерения",
            unitOfMeasure: "Единица измерения",

            // weight
            g: "г",
            kg: "кг",

            // liquid
            ml: "мл",
            l: "л",

            // length
            mm: "мм",
            cm: "см",
            m: "м",
            km: "км",
            ft: "фут",

            // cubic meter
            m3: "㎥",

            // pic
            pc: "шт",
        },
        user: {
            email: "Email",
            emailForResetPassword: "Введите свой адрес электронной почты, и мы вышлем вам ссылку для сброса пароля.",
            emailSent: "Было отправлено электронное письмо, содержащее ссылку, по которой вы можете щелкнуть, чтобы сбросить пароль. Срок действия этой ссылки истекает через 1 час.\n Если вы не получили письмо, проверьте папку со спамом или",
            emailSentToEmployee: "На почту сотрудника отправлена ссылка для установки пароля для входа. Срок действия этой ссылки истекает через 1 час",
            tryAgain: "попробуйте еще раз",
            send: "Отправить",
            password: "Пароль",
            newPassword: "Новый пароль",
            repeatPassword: "Подтвердить пароль",
            resetPassword: "Сброс пароля",
            forgotPassword: "Забыли пароль?",
            passwordChanged: "Ваш пароль успешно изменен",
            resetTokenExpired: "Эта ссылка устарела или уже используется,",
            errors: {
                emailExists: "Этот эмейл уже существует. Укажите другой",
            },
        },
        validator: {
            required: "Нужно заполнить",
            choose: "Выберите",
            type: {
                int: "Требуется целое число",
                number: "Требуется цифра",
                date: "Введено неправилная дата",
                email: "Введите правильный email",
                strongPassword: "Пароль должен содержать буквы, цифры и состоять минимум из 8 символов",
                phone: "Введите правильный номер телефона",
                notEnoughProductsInWarehouse: "Недостаточно товаров на складе",
                thirteenDigit: "Введите 13-значный номер",
                amount: "Введено неправилная сумма"
            },
        },
        warehouse: {
            title: "Склад",
            add: "Добавить склад",
            name: "Название склада",
            deleteWarning: "На складе есть товары, которые удаляются. Пожалуйста, переместите товары на другой склад!",
            choose: "Выберите склад",
            remainder: "Остаток",
            amountSalePrice: "Сумма продажной цены",
            amountPurchasePrice: "Сумма покупной цены",
            TotalAmountProducts: "Общее количество товаров",
            residueInWarehouse: 'Остаток на складе'
        },
    },
    uz: {
        actions: "Harakat",
        active: "Faol",
        add: "Qo'shish",
        addDebt: "Qarz qo'shish",
        debtPayingTime: "Qarzni to'lash sanasi",
        debtPayingTimeNotCome: "Qarzni to'lash sanasi hali kelmadi",
        debtPayingTimeCome: "Qarzni to'lash sanasi keldi",
        debtPayingTimeGone: "Qarzni to'lash sanasi o'tib ketdi",
        additional: "Qo'shimcha",
        additionalInformation: "Qo'shimcha ma'lumot",
        advice: "Maslahat",
        amount: "Miqdor",
        boughtPrice: "Sotib olish narxi",
        beforeLeaveAdvice: 'Rostdan ham sahifani tark etmoqchimisiz? Sizda saqlanmagan o\'zgarishlar bor!',
        cancel: "Bekor",
        category: "Kategoriya",
        collapseSidebar: "Panelni yopish",
        connectionRefused: "Internetingiz yoqilganmi? Server bilan a'loqa yo'q",
        currency: "Valyuta",
        createdAt: "Yaratilgan sana",
        date: "Sana",
        debt: "Qarz",
        debtAmount: "Qarz miqdori",
        delete: "O'chirish",
        download: 'Yuklab olish',
        cancelDelete: "O'chirilmasin",
        deleteConfirm: "Rostdan ham \"{name}\" ni o'chirmoqchimisiz?",
        deleteConfirmSimple: "Haqiqatdan ham o'chirmoqchimisiz?",
        detailed: "Batafsil",
        edit: "O'zgartirish",
        errorData: "Xato",
        errorDate: "Noto'g'ri sana kiritildi",
        empty: "Bo'sh",
        export: "Tarozi uchun fayl yaratish",
        goBack: "Ortga",
        hasPayed: "To'langanmi?",
        home: "Bosh sahifa",
        id: "ID",
        loginSystem: "Tizimga kirish",
        main: "Asosiy",
        moreInfo: "Ko'proq ma'lumot olish",
        more: "Yana",
        name: "Nomi",
        move: "Ko'chirish",
        new: "Yangi",
        no: "Yo'q",
        noData: "Ma'lumotar yo'q",
        notInfo: "Siz qidirgan ma'lumot topilmadi",
        ok: "Ok",
        onCredit: "Qarzga",
        overPayed: "Qarz miqdoridan ortiq to'landi",
        pay: "To'lash",
        payed: "To'langan",
        payedAmount: "To'lov miqdori",
        payType: "To'lov turi",
        payDebt: "Qarzni to'lash",
        payWarning: "Diqqat! Haqiqatda quyidagi summani to'lamoqchimisiz?",
        purchase: "Sotib olish",
        purchasePerUnit: "Sotib olinish narxi ",
        profile: 'Profil',
        print: "Chop etish",
        price: "Narx",
        pcs: 'ta',
        refresh: "Yangilash",
        refreshInfo: "Ma'lumotlar yangilanmoqda...",
        search: "Izlash",
        save: "Saqlash",
        select: "Tanlang",
        selected: "Tanlandi",
        selectError: "Kechirasiz, siz qidirayotgan variant yo'q",
        sellingPrice: "Sotish narxi",
        saved: "Saqlandi",
        technicalWorks: "Xizmat sifatini oshirish maqsadida texnik ishlar olib borilmoqda",
        total: "Umumiy",
        totalBalance: "Umumiy balans",
        totalSalesAmount: 'Jami xarid summasi',
        totalPrice: "Umumiy narx",
        transactions: "Tranzaksiyalar",
        trash: "O'chirilgan mahsulotlar",
        treeView: "Daraxt ko'rinishida",
        unknownError: 'Xatolik yuz berdi :(',
        view: "Ko'rish",
        warning: "Diqqat",
        yes: "Ha",
        year: "Yil",
        loss: 'Yo\'qotish',
        atWork: {
            atWork: "Ish joyida",
            againEntry: "Tizimga qayta kirmoqchisiz",
            againEntryReason: "Qayta kirish sababi",
            cantEntry: "Tizimdan qayta foydalanish uchun cheklov mavjud",
            limit: "Ruxsat etilgan tizimga kirib chiqishlar soni: 3 marta",
            closeNow: "Hoziroq yopish",
            currentTime: "Xozirgi vaqt",
            confirmFinishWork: "Ishdan erta ketishni tasdiqlaysizmi?",
            ended: "Ish tugatdi",
            yourJobTime: "Ish vaqtingiz",
            greeting: "Assalomu alaykum!",
            startJob: "Ishni boshlash",
            started: "Ish boshladi",
            today: "Bugun",
            toJobTime: "Ish vaqtingiz boshlanishigacha",
            title: "Ishdagilar",
            late: "Ishga kech qoldingiz",
            lateTime: "Kechga qolish vaqti",
            reasonLate: "Kechikish sababi",
            minSymbolAmount: "Kamida 10 ta belgi kiriting",
            hour: "soat",
            minute: "daqiqa",
            jobTime: "Ish vaqti",
            from: "dan",
            to: "gacha",
            reason: "Sabab",
            finishWork: "Ishni yakunlash",
            wantFinishWorkBeforeTime: "Ish vaqti tugamasdan avval yakunlamoqchimisiz?",
        },
        autoOrder: {
            title: "Avtobuyurtma",
            modalTitle: "Avtobuyurtma sanalari",
            orderDate: 'Avtobuyurtma sanasi',
            lastOrderPeriod: 'Oxirgi avtobuyurtma davri',
            lastOrderDate: 'Oxirgi avtobuyurtma sanasi',
            order: 'Buyurtma',
            new: 'Yangi avtobuyurtma',
            daily: 'kunlik',
            period: 'Buyurtma davri',
            amount: 'Buyurtma miqdori',
            sum: 'Buyurtma summasi',
            sold: 'Sotilgan',
            soldOutDate: 'Tugagan sana',
            status: 'Buyurtma xolati',
            marja: 'Foyda marjasi',
            prepared: 'Buyurtma tayyorlangan',
            saleRate: 'Sotilish miqdori',
            avgSaleRate: 'Sotish/kun',
            productPriceSum: 'Mahsulotlar summasi (oxirgi xarid narxida)',
            makeOrder: 'Buyutma berish',
            ordered: 'Buyurtma berilgan',
            excelFileForPurchase: 'Xarid uchun excell fayl',
            noSale: 'Tanlangan davr uchun savdo mavjud emas',
            noNeedOrder: 'Buyurtmaga ehtiyoj yo\'q'
        },
        order: {
            onlineOrder: 'Onlayn buyurtma'
        },
        debtor: {
            debtSuccessPaid: "Qarzdorlik muvaffaqiyatli to'landi",
            indebtedness: "Qarzdorlik"
        },
        error: {
            purchaseCancel: "Mahsulotlarning bir qismi allaqachon sotilgan",
            access: "Bu vazifaga yetarlicha huquqingiz yo'q",
            overLimit: "Ta'rif rejangiz bo'yicha berilgan miqdordan ortiq qo'sha olmaysiz."
        },
        company: {
            owner: "Korxona egasi",
            accessTime: 'Korxona aktivligi {date} gacha',
            activePeriod: 'Korxona aktivligi',
            create: "Ro'yxatdan o'tish",
            registeredDate: "Ro'yxatdan o'tgan sana",
            employeesCount: "Xodimlar soni",
            name: "Korxona nomi",
            telephone: "Telefon raqami",
            namePlaceholder: "Do'kon",
            title: "Korxona",
            remaining: {
                productsPrice: "Bor mahsulotlar narxi",
                hasMoney: "Bor mablag'",
                ourDebt: "Bizning qarz",
                oweUs: "Bizga qarz",
            },
            managerId: "Menejer id raqami",
            managerError: "Bunday raqamli menejer mavjud emas",
            month: {
                Jan: 'Yanvar',
                Feb: 'Fevral',
                Mar: 'Mart',
                Apr: 'Aprel',
                May: 'May',
                Jun: 'Iyun',
                Jul: 'Iyul',
                Aug: 'Avgust',
                Sep: 'Sentyabr',
                Oct: 'Oktyabr',
                Nov: 'Noyabr',
                Dec: 'Dekabr',
            },
        },
        companyRequisites: {
            baseCurrency: "Asosiy valyuta",
            tin: "STIR",
            gceo: "KTUT",
            legalAddress: "Yuridik manzil",
            physicalAddress: "Jismoniy manzil",
            chiefDirector: "Bosh direktor",
            addTin: "STIR kiriting",
            addGceo: "KTUT kiriting",
            addLegalAddress: "Yuridik manzilni kiriting",
            addPhysicalAddress: "Jismoniy manzilni kiriting",
            addChiefDirector: "Bosh direktor ismini kiriting",
            moneyInWallet: "Bor mablag'ni kiriting"
        },
        customer: {
            choose: "Mijozni tanlang",
            customers: "Mijozlar",
            title: "Mijoz",
            numberOfCustomers: "Mijozlar soni",
            numberOfDebtors: "Qarzdorlar soni",
            purchase: "Harid",
            add: "Mijoz qo'shish",
            averageCheck: "O'rtacha chek",
            canDeleteSaleWarning: "Diqqat! Ushbu ishchiga barcha savdo tranzaksiyalarini o'chirish huquqi beriladi",
            dateAdd: "Qo'shilgan sana",
            debtors: "Qarzdorlar",
            cashback: {
                title: "keshbek",
                amount: "Mavjud keshbek",
                notHaveCashback: "Ushbu mijozda keshbek mavjud emas!",
                notHaveCashbackCard: "Ushbu mijozda keshbek kartasi mavjud emas!",
                residue: "Qoldiq keshbek",
                payFromCashback: "Keshbekdan to'lov",
                numberNotAvailable: "Bu raqam tizimda mavjud. Iltimos, boshqa raqam kiriting.",
                totalAmount: "Umumiy keshbek summasi"
            },
            type: "Turi",
            info: "Mijoz haqida ma'lumot",
            hasDebts: "Ushbu mijozning qarzlari bor",
            deleteAnyway: "Qarzlarni ununtish va o'chirish",
            notExist: "Ayni vaqtda tizimda ushbu mijoz mavjud emas yoki o'chirilgan",
            deleteCustomWarning: "Diqqat! Ushbu Mijoz tizimdan to'liq o'chiriladi. Tasdiqlaysizmi?",
            personalInformation: "Shaxsiy ma'lumotlar",
            loyaltyCard: "Sodiqlik kartasi",
            bankAccountNum: "Bank hisob raqami",
            createdAtCompany: "Korxona ochilgan sana",
            webSite: "Web-sayt",
            scoreAndDiscount: "Ball to'plash va chegirma qilish",
            score: "Ball",
            discount: "Chegirma",
            factAddress: "Fakt manzili",
            firstPurchase: "Birinchi xarid sanasi",
            opportunities: "Imkoniyatlar",
            discountPercent: "Chegirma foizda",
            totalSalesAmount: "Umumiy savdo summasi",
            discounted: "Chegirma qilish",
            discountAmount: "Chegirma summasi",
        },
        currencyRate: {
            choose: "Valyutani tanlang",
            centralBankRate: 'Markaziy bank kursi',
            change: 'O\'zgarish',
            companyRate: 'Kompaniya valyutalar kursini kiriting:',
            currencyRate: 'Valyuta kurslari',
            currencyName: 'Valyutalar nomlari',
            officialRate: 'Markaziy bankning bugungi sana uchun rasmiy kursi:',
            ourRate: 'Bizning kurs:',
            rate: 'Kurs',
            rub: 'Rossiya rubli',
            saveRate: 'Ushbu kursni saqlash',
            uzs: 'O\'zbek so\'mi',
            symbol: 'Ramzi',
            usd: 'AQSH dollari',
            sum: 'so\'m'
        },
        employee: {
            title: "Ishchi",
            canAuth: "Tizimga kira oladi",
            position: "Lavozim",
            cashier: "Kassir",
            workTimeAndSalary: "Ish vaqtlari va maosh",
            hiredDate: "Ishga kirgan sana. (kun/oy/yil)",
            personalInformation: "Shaxsiy ma'lumotlar",
            belongToApp: "Tizimga oid",
            telegram: "Telegram",
            jobEndTime: "Ish vaqtingiz tugashiga {time} daqiqa qoldi!",
            jobType: {
                title: "Ish tartibi",
                hourly: "Soatlik",
                daily: "Kunlik",
                weekly: "Haftalik",
                monthly: "Oylik"
            },
            jobSchedule: {
                title: "Ish grafigi"
            },
            salary: "Maosh",
            wasBornDay: "Tug'ilgan yili:",
            workTimeFrom: "Ish vaqti (dan)",
            workTimeTo: "Ish vaqti (gacha)"
        },
        excel: {
            row: 'qator',
            import: "Import",
            importAgain: "Yana import qilish",
            notImport: "Import qilinmasin",
            selectEachColumn: 'Har bir ustun vazifasini tanlang',
            choiceExcelFile: 'Excel fayl tanlang',
            importedFile: "Bazaga {lines} qator ma'lumot kiritildi",
            checkData: "Noto'g'ri ma'lumot yuborildi",
            hasEmptyFields: "Bo'sh maydonlar mavjud",
            validExcel: 'Iltimos, to\'g\'ri Excel faylini yuklang',
            saleCurrency: "Sotish valyutasi",
            purchaseCurrency: "Sotib olish valyutasi",
        },
        expirationProduct: {
            soldOut: "Sotilgan",
            notSold: "Sotilmagan",
            expiredProductsTotalAmount: "Muddati tugagan mahsulotlar soni:",
            productsFiveDaysLeftExpire: "Muddati tugashiga 5 kun qolgan maxsulotlar soni:",
            productsTenDaysLeftExpire: "Muddati tugashiga 10 kun qolgan maxsulotlar soni:",
        },
        filter: {
            all: "Barchasi",
            clear: "Tozalash",
            filters: "Filtrlar",
            fromAmount: "Miqdordan",
            fromPrice: "Narxdan",
            fromDateToDate: "Yil-oy-sana",
            fromSellingPrice: "Sotish narxidan",
            fromSum: "Summadan",
            thisDay: "Ushbu (yil-oy-sana) dan",
            thisTime: "Sanadan...",
            toAmount: "Miqdorgacha",
            toPrice: "Narxgacha",
            toSellingPrice: "Sotish narxigacha",
            toTime: "Sanagacha...",
            toDay: "Ushbu (yil-oy-sana) gacha",
            toSum: "Summagacha",
        },
        finance: {
            financialSituation: "Finansoviy xolat",
            balance: "Balans",
            title: "Moliya",
            counts: "Hisoblar",
            count: "Hisob",
            report: "Hisobot",
            fromCount: "Hisobdan",
            whichCount: "Hisobga",
            newCount: "Yangi hisob",
            initialAmount: "Boshlang'ich balans",
            deleteInfo: "Kategoriya muvafaqqiyatli o'chirildi!",
            deleteCountInfo: "Hisob muvafaqqiyatli o'chirildi!",
            transfer: "O'tkazma",
            income: {
                sale: "Savdo",
                purchase: "Xarid qilish",
                rent: "Arenda",
                salary: "Oylik",
                communal: "Kamunal",
                debt: "Qarz olish",
                credit: "Qarz berish",
                paymentSystem: "Tizim uchun to'lov",
            }
        },
        import: {
            advice: 'Maxsulotlarni import qilish uchun <router-link to="https://boshqar.com/uz" target="_blank">kompyuter versiyasidan</router-link> foydalaning',
        },
        image: {
            title: "Rasm",
            choiceImageFile: 'Rasm tanlang',
            validImage: 'Iltimos, to\'g\'ri Rasm faylini yuklang'
        },
        incomeAndOutcome: {
            allIncome: "Barcha kirimlar",
            allOutlay: "Barcha chiqimlar",
            title: "Kirim / Chiqim",
            income: "Kirim",
            outlay: "Chiqim",
            Status: "Status",
        },
        inventory: {
            advice: 'Maxsulotlarni inventorizatsiya qilish uchun <router-link to="https://boshqar.com/uz" target="_blank">kompyuter versiyasidan</router-link> foydalaning',
            title: "Inventarizatsiya",
            result: "Natija",
            difference: "Farq",
            sumDifference: "Summada farq",
            deficit: "Kam chiqqan",
            profit: "Ko'p chiqqan",
            amount: "Tizimdagi qoldiq",
            realAmount: "Xaqiqiy qoldiq",
            allProducts: "Barcha mahsulotlar",
            fitProducts: "To'g'ri kelgan mahsulotlar",
            nonFitProducts: "Farq qilgan mahsulotlar",
            profitProducts: "Ortiqcha mahsulotlar",
            deficitProducts: "Yetmagan mahsulotlar",
            finance: "Moliya bo'yicha",
            responsiblePerson: "Mas'ul shaxs",
            sumSelectedProducts: "Tanlangan mahsulotlar summasi",
            sumFitProducts: "To'g'ri kelgan mahsulotlar summasi",
            sumProfitProducts: "Ortiqcha mahsulotlar summasi",
            sumDeficitProducts: "Yetmagan mahsulotlar summasi",
            sumDifferenceProducts: "Farq qilgan mahsulotlar summasi",
            syncing: "Sinxronizatsiya qilinmoqda...",
            synced: "Sinxronlangan",
            sync: "Sinxronlash"
        },
        kpi: {
            title: "KPI",
            type: "KPI turi",
            condition: "KPI sharti",
            conditionIssue: "KPI berish shartlari",
            forAllProducts: "Barcha mahsulotlarga",
            forSomeProducts: "Ayrim mahsulotlarga",
            forExactProduct: "Bitta mahsulotga",
            finish: "Yakunlash",
            products: "Mahsulotlar",
            sum: "KPI rejasi",
            salePlan: "Savdo rejasi",
            saleSum: "Savdo summasi",
            status: "Status",
            period: {
                title: "Davr",
                daily: "Kunlik",
                weekly: "Haftalik",
                monthly: "Oylik"
            },
            onlyActives: "Faqat faollar",
            plan: "KPI/Reja",
            planDone: "Reja bajarildi",
            done: "Bajarildi",
            indicatorOfEmployees: "Xodimlar ish ko'rsatkichi",
            date: {
                title: "Sana",
                startDate: "Boshlanish sanasi",
                endDate: "Tugash sanasi"
            },
            daysOfKpi: "KPI kunlari",
            participants: "KPI ishtirokchilari",
            forAllEmployees: "Barcha xodimlarga",
            forSomeEmployees: "Ayrim xodimlarga",
            employees: "Xodimlar",
            bonus: {
                title: "Bonus",
                forEmployee: "Xodim nima oladi?",
                onSum: "Summada bonus",
                fromIncome: "Foydadan foiz",
                product: "Mahsulot",
                percentAmount: "Foiz miqdori",
                bonusAmount: "Bonus miqdori",
                given: "Berilgan",
                give: "Berish",
                received: "Olingan",
                notReceived: "Olinmagan"
            },
            employee: {
                title: "Xodim F.I.Sh",
            },
            salary: {
                mainTitle: "Maosh/To'lovlar",
                salary: "Oylik",
                income: "Daromad",
                title: "Maoshi",
                payForNewMonth: "Yangi oy uchun maosh to'lash",
                forNewMonth: "Yangi oy uchun",
                forWhatMonth: "Qaysi oy uchun",
                fromWhichCount: "Qaysi hisobdan to'lansin?",
                payedAmount: "To'lov miqdori",
                payed: "To'landi",
                pay: "To'lov",
                historyOfPay: "To'lovlar tarixi",
                totalPayed: "Jami to'langan maosh",
                more: "yana",
                payDate: "To'lov sanasi",
            },

        },
        login: {
            title: "Kirish",
            logout: "Chiqish",
            success: 'Salom, {login}!',
            error: "Email yoki parol noto'g'ri",
            bye: 'Hayr...',
        },
        notActive: "faol emas",
        person: {
            title: "Odam",
            additionalName: "Otasining ismi",
            age: "yosh",
            contacts: "Bog'lanish",
            year: "yil",
            givenName: "Ism",
            familyName: "Familiya",
            birthday: "Tug'ilgan kun (kun/oy/yil)",
            fullName: "FIO",
            yourGivenName: "Ismingiz",
            yourFamilyName: "Familiyangiz",
            telephone: "Telefon raqami",
            telegram: "Telegram",
            otherInformation: "Boshqa ma'lumotlar",
            gender: {
                title: "Jinsi",
                man: "Erkak",
                woman: "Ayol",
            },
        },
        plan: {
            title: "Narxlar",
            compare: "Rejalar",
            hasExpired: "Tizimdan foydalanish vaqtingiz tugadi",
            mainTitle: "Tizimdan foydalanish uchun oylik to'lov tarif rejalariga mos ravishda belgilanadi.",
            subTitle: "Agar 17% tejamoqchi bo'lsangiz, bir yilga to'lov qilishni tavsiya qilamiz.",
            conditions: "Birinchi 7 kun tizimdan foydalanish bepul! Ushbu vaqtda, pul to'lamasdan tizimni sinab ko'rishingiz mumkin! Dastur bepul davrida Premium tarifda ishlaydi",
            statisticsTitle: "Kunlik, oylik, yillik. Kunlik tushum, grafik ko’risnishida top maxsulotlar, qaysi maxsulot ko’p miqdorda sotilyapti, hamma tranzaksiyalarni masofadan turib kuzatish imkoniyati",
            statistics: "Statistika",
            employeesCount: "Ishchilar soni",
            warehousesCount: "Omborlar soni",
            suppliersCount: "Yetkazib beruvchi",
            customersCount: "Mijozlar soni",
            priceForMonth: "Narxlar oyiga",
            priceForYear: "Narxlar yiliga 17% chegirma bilan",
            unlimit: "cheksiz",
            feature: "Imkoniyat",
            planChangeWarning: "Siz imkoniyati yuqori bo'lgan ta'rif rejadan imkoniyatlari kam bo'lgan ta'rifga o'tmoqdasiz. Bu holatda sizda mavjud bo'lgan omborlar ta'rif rejangizga mos ravishda kamaytiriladi, ortiqchasi esa o'chirib yuboriladi. O'chirib yuborilgan omborlardagi mahsulotlar mavjud omborlarga ko'chiriladi. Davom etishga rozimisiz?"
        },
        printView: {
            directorCompany: 'Rahbar',
            totalSum: 'Jami summa',
            printA4: 'Yuk xati chop etish',
            printCheck: 'Chekda chop etish',
            printEpos: 'Epos chekini chop etish',
            receipt: "Chek №",
            addInfo: "Chek uchun qo'shimcha ma'lumot"
        },
        product: {
            title: "Mahsulot",
            title2: "Mahsulotlar",
            add: "Mahsulot qo'shish",
            addMany: "Ko'p miqdorda qo'shish",
            name: "Mahsulot nomi",
            choose: "Mahsulotni tanlang",
            chooseAndAdd: "Mahsulotni tanlang | qo'shing",
            count: "Mahsulotlar soni",
            barcode: "Shtrix-kod",
            formatBarcode: "kamida 7 ta raqam kiriting",
            hasExpirationDate: "Yaroqlilik muddati yo'q",
            expirationDate: "Yaroqlilik muddati",
            export: "Eksport",
            restore: "Tiklash",
            restoreWarning: "Diqqat! Belgilangan maxsulotlar qayta tiklanadi. Tasdiqlaysizmi?",
            notRestored: "Belgilangan maxsulotlar tizimda borligi uchun qayta tiklab bo‘lmadi.",
            hardDeleteWarning: "Diqqat! Belgilangan mahsulotlar tizimdan to'liq o'chiriladi. Tasdiqlaysizmi?",
            productAmount: "Mahsulot miqdori",
            productExpired: "Mahsulotni muddati",
            productImage: "Mahsulot rasmi",
            expired: "Muddati tugagan",
            exportBarcode: "Dona yoki kg ko'rsatkichini ham eksport qilish",
            datePurchase: "Kelgan sana",
            pricePurchase: "Kelgan narxi",
            manufacturerDate: "Ishlab chiqarilgan sana",
            withoutExpirationDate: 'Yaroqlilik muddati ko\'rsatilmagan mahsulotlar uchun ushbu sana avtomatik ko\'rsatiladi'
        },
        productPriceModify: {
            title: "Narxni o'zgartirish",
            newDocument: "Yangi xujjat",
            prognosis: "O'zgarish prognozi",
            difference: "Farq miqdorda",
            price: "Narxi",
            marja: "Marja",
            newPrice: "Yangi narx",
            oldPrice: "Eski narx"
        },
        productPurchase: {
            title: "Mahsulot xarid qilish",
            few: "Ko'p miqdorda xarid qilish",
            pricePerUnit: "{name} uchun narx",
            reminder: "Eslatma",
            alertAmount: "Eslatish miqdori",
            debtAmount: "Qarz miqdori",
            todayPurchasesAmount: "Bugungi harid summasi: ",
            price: "Xarid narxi",
            paymentAmount: "To'lov summasi",
            paymentHistory: "To'lov tarixi",
            paymentDate: "To'lash sanasi"
        },
        productsInWarehouse: {
            title: "Ombordagi mahsulotlar",
            writeOffDescription: "Hisobdan chiqarish sababini kiriting",
            writeOff: "Hisobdan chiqarish",
            wroteOff: "Hisobdan chiqarilgan mahsulotlar",
            reason: "Sabab",
            changeWarehouse: "Ombordagi mahsulotlarni ko'chirish",
            changingProductsAmount: "{amount} ta mahsulot",
            deleteIsNotify: "Ushbu mahsulotni ogohlantirish oynasidan olib tashlamoqchimisiz?"
        },
        promoNew: {
            forWhom: 'Kim uchun',
            bureaucracy: {
                title: 'Qog\'ozbozlik jonga tegdimi?',
                text: 'Mahsulotingizni boshqar.com dasturi orqali boshqaring.',
                anywhere: 'Istagan joyda',
                anyDevice: 'Istagan qurilmangizda',
                robbery: 'O’g’riliklar, mavhumliklarga chek qo’yish',
                only: 'Atigi',
                perMonth: '/ oyiga',
                test: 'Sinab ko\'rish',
                howItWorks: 'Qanday ishlaydi',
            },
            forAllBusiness: {
                title: 'Har qanday biznes uchun to\'g\'ri keladi',
                text: 'Boshqar sizning talablaringizga qarab moslasha oladi, bu xoh kichik biznes bo’lsin, xoh katta korxona',
                supermarket: 'Supermarketlar',
                pharmacy: 'Aptekalar',
                perfumery: 'Parfumeriya',
                plumbing: 'Santexnika',
                foodStore: 'Oziq-ovqat do\'konlari',
                clothingStore: 'Kiyim do\'konlari',
                constructionStore: 'Qurilish mollari',
                variousBusiness: 'Har turdagi biznes'
            },
            sale: {
                sale: 'SAVDO',
                title: 'Savdogarlar uchun eng qulay imkoniyatlar',
                text: {
                    sellProduct: 'Mahsulotlaringizni savdo sahifasida soting',
                    accountOnDept: 'Qarzga sotilgan mahsulotlarni hisoblash',
                    saleStatistics: 'Xarid qilish va sotish  bo\'yicha batafsil ma\'lumotlarni olish'
                },
            },
            product: {
                product: 'MAHSULOTLAR',
                title: 'Mahsulotlarni erkin boshqarish',
                text: 'Dastur orqali mahsulotingizni boshqarishingiz mumkin. Qancha narxga sotib olganingizni yozing. Ularni sotayotganingizda tizim omborda qancha qolgani, qancha foyda qilganingizni o’zi hisoblaydi.',
                analytics: {
                    analytics: 'Analitika',
                    analyticsText: 'O\'rnatilgan hisobotlar biznesingiz haqidagi muhim savollarga javob berishga yordam beradi - qaysi lavozimlar eng daromadli, qaysi xodimlarning o\'rtacha tekshiruvi yuqori, oyiga chegirmalarga qancha pul sarflanadi.',
                },
                finance: {
                    finance: 'Moliya',
                    financeText: 'Korxonangizda qancha mablag’ bor, barcha mahsulotlar narxi qancha, sizga odamlarning qancha qarzi bor-u, sizning boshqalardan qancha qarzingiz borligini va shunga o’xshash boshqa ma’lumotlarni, statistikalar bilan tanishish mumkin!',
                },
                storeText: 'Har xil omborlar yarating va mahsulotlaringizni yaratgan omborlaringizda saqlang!',
                marketing: {
                    marketing: 'Marketing',
                    marketingText: 'Sotuvchi va haridor o\'rtasidagi tovar, mahsulot yoki xizmatlar almashinuvi natijasida kompaniyaning qiymati oshiriladi!'
                },
            },
            observe: {
                observe: 'KUZATUV',
                title: 'Biznesingizni dunyoning xohlagan nuqtasidan boshqaring',
                text: 'Android uchun bepul Boshqar mobil ilovasi yordamida korxonangizni smartfoningiz orqali boshqaring',
                checkCalculation: 'Hisob-kitoblarni tekshirish',
                checkRemainder: 'Qoldirlarni boshqarish',
                addTransaction: 'Chiqim tranzaksiyalarini qo\'shish'
            },
            customer: {
                customer: 'MIJOZ',
                title: 'Mijozlar bilan bir tizimda bo’lish',
                text: 'Tizimga mijozlaringizni kiritishingiz mumkin. Mahsulot sotayotganda qaysi mijozga sotayotganingizni ham ko’rsatish imkoningiz bor. Mijozlar shaxs, yoki korxona bo’lishi mumkin'
            },
            transaction: {
                transactions: 'TRANZAKSIYALAR',
                title: 'Barcha tranzaksiyalar qo’lingizda',
                text: 'Barcha sotgan va sotib olgan mahsulotlaringizni istalgan paytda ko’rishingiz mumkin. Qarzga sotilgan mahsulotlarni puli to’langanligini ham belgilash mumkin.',
            },
            employee: {
                employees: 'ISHCHILAR',
                title: 'Istalgancha ishchilarni tizimga kiritishingiz mumkin',
                text: 'Istasangiz ularga tizimdan foydalanish uchun ruxsat bering. Misol uchun bir ishchingiz ombor uchun mahsulot sotib olishga huquqi bo’lsa, ikkinchisi faqat ularni sotish uchun huquqi bo’lsin. Kimdir esa faqat mijozlar bilan shug’ullansin',
            },
            security: {
                security: 'XAVFSIZLIK',
                title: 'Eng muhimi: hech qanday o’g’rilikka yo’l qo’yilmaydi',
                text: 'Odatda eng yoqimsiz narsalardan biri bu hodimlarga ishonchsizlikdir. Bizning dasturimiz shunday aniq hisob olib boradiki ko’nglingiz doim xotirjam bo’lsin. Hech qanday o’grilik, mavhumlikka yo’l qo’yilmaydi. Hammasi shaffof bo’ladi. Telefoningiz orqali har bir operatsiyalarni kuzatib tura olasiz',
            },
            tariff: {
                paymentTerm: 'To\'lov muddati',
                smallBusiness: 'Kichik biznes',
                middleBusiness: 'O\'rta biznes',
                bigBusiness: 'Katta bizness'
            },
            comingSoon: {
                mainText: 'Tez kunda biznesingiz uchun yanada ko’proq yechimlar',
                internetStore: 'INTERNET DO\'KON',
                taxServices: 'SOLIQ XIZMATLARI',
                discounts: 'AJOYIB CHEGIRMALAR',
                otherServices: 'VA BOSHQA BIR QANCHA XIZMATLAR'
            },
            gratitude: 'Boshqar.com jamoasi uzoq yillar davomida sizga qulay va foydali dastur yaratish uchun xizmat qilib kelmoqda. Bizni tanlaganingiz uchun rahmat!!!'
        },
        role: {
            ROLE_SELLER: "Sota oladi",
            ROLE_STOREKEEPER: "Omborni boshqara oladi",
            ROLE_PRODUCT_PURCHASER: "Mahsulotlarni harid qila oladi",
            ROLE_PRODUCT_MANAGER: "Mahsulotlarni boshqara oladi",
            ROLE_PRODUCT_PURCHASE_HISTORY: "Mahsulotlar haridi tarixini ko'ra oladi",
            ROLE_SALE_HISTORY: "Sotuv tarixini ko'ra oladi",
            ROLE_CUSTOMER_MANAGER: "Mijozlarni boshqara oladi",
            ROLE_EMPLOYEE_MANAGER: "Ishchilarni boshqara oladi",
            ROLE_SEE_CUSTOMER_DEBTS: "Qarzlarni ko'ra oladi",
            ROLE_SUPPLIER_MANAGER: "Yetkazib beruvchilarni boshqara oladi",
            ROLE_SERVICE_MANAGER: "Xizmatlarni boshqara oladi",
            ROLE_SEE_SUPPLIER_DEBTS: "Qarzlarni ko'ra oladi",
            ROLE_CAN_DELETE_SALE_HISTORY: "Savdo tranzaksiyalarini o'chira oladi",
            ROLE_DISCOUNT_MANAGER: "Chegirmalarni boshqara oladi",
            ROLE_KPI_MANAGER: "KPI qo'ya oladi",
            ROLE_INVENTORY_MANAGER: "Inventarizatsiya qila oladi",
            ROLE_TAXES_MANAGER: "Soliqni boshqara oladi",
            ROLE_AUTOORDER_MANAGER: "Avtobuyurtma qila oladi",
        },
        returnProducts: {
            deficitQuantity: "Miqdor yetmaydi",
            return: "Qaytarish",
            returnAmount: "Qaytarish miqdori",
            returnDate: "Qaytarish sana",
            returnSupplier: "Taminotchiga qaytarish",
            returnCustomer: "Mijozdan qaytarish",
            newReturn: "Yangi qaytarish",
            returnSum: "Qaytarish summasi",
            saleDate: "Savdo sanasi",
            totalSum: "Umumiy summa",
            totalResidue: "Jami qoldiq",
            type: "xil",
            typeProduct: "xil mahsulot",
        },
        sale: {
            editSaleWarning: "Diqqat! Quyidagi tranzaksiyadan nusxa olinadi va ushbu tranzaksiya bekor qilinadi. Tasdiqlaysizmi?",
            deleteSaleWarning: "Diqqat! Ushbu tranzaksiya tizimdan to'liq o'chiriladi. Tasdiqlaysizmi?",
            draft: "Qoralama",
            title: "Savdo",
            todayTradeAmount: "Bugungi savdo summasi:",
            newSale: "Yangi savdo",
            sum: "Summa",
            totalSum: 'Umumiy summa',
            integration: "Soliq bilan integratsiya",
            integrationWarningCantSend: "Soliq idorasiga faqat YAGONA ELEKTRON MILLIY KATALOGda mavjud bo'lgan mahsulotlar yuborilishi mumkin. Quyidagi mahsulotlarning xech birida MXIK mavjud emas. Ushbu mahsulotlarni soliq bilan integratsiya qilib bo'lmaydi. Davom etasizmi?",
            integrationWarningCanSend: "Soliq idorasiga faqat YAGONA ELEKTRON MILLIY KATALOGda mavjud bo'lgan mahsulotlar yuborilishi mumkin. Quyidagi mahsulotlarni MXIKi mavjud emas. Ular chekda ko'rsatilmaydi",
            confirm: "Tasdiqlaysizmi?",
            confirmed: "Tasdiqlash",
            information: "Savdo ma'lumotlari",
            integrationTitle: "Ushbu sozlanma yoqilgan vaqtda sotilgan har bir mahsulot avtomatik ravishda soliq bilan integratsiya qilinadi",
            finalSum: 'Jami summa',
            thankPurchase: 'Xaridingiz uchun rahmat',
            seller: "Sotuvchi",
            purchaseHistory: "Savdo tarixi",
            cash: 'Naqd',
            oddMoney: 'Qaytim',
            notEnoughPayed: "To'lov miqdori yetarli emas (qarzga savdo?)",
            saleSum: 'Savdo summasi',
            tax: {
                inPrice: 'Soliq mahsulot narxiga kiritilgan',
                onPrice: 'Mahsulot narxi ustiga soliq',
                withoutTax: 'Soliqsiz',
                inPriceOnCheck: 'Shu jumladan ',
                title: "Soliq",
                name: 'Soliq nomi'
            },
            discount: {
                title: "Chegirma",
                make: "Chegirma qilish",
                startDate: 'Boshlanish vaqti',
                endDate: 'Tugash vaqti',
                discountName: 'Chegirma nomi',
                discountCondition: 'Chegirma sharti',
                conditionsForDiscountingProducts: 'Chegirma berish shartlari',
                forAllProducts: 'Barcha mahsulotlar uchun',
                forSomeProducts: 'Ba\'zi mahsulotlar uchun',
                amountForDiscount: 'Chegirma uchun pul miqdori',
                minimalSum: 'Minimal summa',
                discountDays: 'Chegirma kunlari',
                discountParticipants: 'Chegirma ishtirokchilari',
                forAllCustomers: 'Barcha mijozlar',
                forSomeCustomers: 'Ba\'zi mijozlar',
                discountBonus: 'Chegirma bonusi',
                customersGet: 'Mijozlar nima oladi',
                discountSum: 'Summali chegirma',
                discountPercent: 'Foizli chegirma',
                discountProduct: 'Mahsulot sovg\'aga',
                discountType: 'Chegirma turi',
                percentAmount: 'Foiz miqdori',
                sumAmount: 'Pul miqdori',
                forTotalSum: 'Umumiy summa uchun',
                forProduct: 'Mahsulot uchun',
                aboutDiscount: 'Chegirma haqida ma\'lumot'
            },
            product: {
                title: "Mahsulotlar",
            },
            transaction: {
                cancel: "Bekor qilish",
                canceled: "Bekor qilingan"
            }
        },
        production: {
            title: 'Ishlab chiqarish',
            productPreparation: 'Mahsulot tayyorlash',
            selectFile: 'Shu yerdan faylni tanlang',
            selectMaterial: 'Homashyo tanlang',
            lossAddition: 'Yo\'qotishlar yoki qo\'shimcha',
            margin: 'Morja',
            composition: 'Tarkibi',
            totalAmount: 'Umumiy miqdor',
            afterCleaning: 'Tozalangandan keyin',
            cost: 'Tannarx',
            additionalOutputs: 'Qo\'shimcha chiqimlar',
            properties: {
                title: 'Xomashyo',
                bestBefore: 'Saqlash muddati:',
                addLossTitle: "Yangi yo'qotish nomini kiriting",
                lossName: "Yo'qotish nomi",
                enterLossName: "Yo'qotish nomini kiriting"
            },
            finishedProduct: {
                title: 'Tayyor mahsulot',
                methodPreparation: 'Tayyorlash usuli',
            },
            category: {
                title: 'Kategoriya'
            },
            transactions: {
                title: 'Tranzaksiyalar'
            }
        },
        scale: {
            title: 'Tarozilar',
            name: 'Tarozi nomi',
            scaleProduct: 'Tarozili mahsulot',
            token: 'Token'
        },
        service: {
            title: "Xizmat",
            services: "Xizmatlar",
            serviceName: "Xizmat nomi",
            addService: "Xizmat qo'shish",
            price: "Narxi",
            servicePrice: "Xizmat narxi",
            addedServices: "xil xizmatlar qo'shildi"
        },
        soon: {
            title: "Tez kunda",
            description: "Tez kunda...",
        },
        statistics: {
            categories: {
                soldProducts: 'Maxsulot sotuvi',
                ourDebt: 'Bizning Qarz',
                profit: 'Sof foyda',
                debtor: 'Bizga qarz',
                totalSale: 'Umumiy savdo',
                cash: 'Naqd pul',
                debt: 'Qarzga',
                bankCard: "Bank kartasi",
                moneyTransfer: "Pul o'tkazish",
                employees: "Ishchilar bo'yicha"
            },
            employee: {
                employee: 'Xodim',
                activity: 'Faollik',
                sum: 'Summa',
                avgReceipt: 'O\'rtacha chek',
                receiptCount: 'Cheklar soni',
                income: 'Foyda'

            },
            byPercent: 'Foiz bo\'yicha',
            byIncome: 'Foyda bo\'yicha',
            byAmount: 'Miqdor bo\'yicha',
            income: 'Foyda',
            payTypes: "To'lov usullari",
            sale: 'Savdo statistikasi',
            service: 'Xizmat statistikasi',
            product: 'Mahsulot statistikasi',
            productDynamic: 'Mahsulot dinamikasi',
            period: 'Davr',
            purchase: 'Xarid statistikasi',
            customer: {
                title: 'Mijoz statistikasi',
                purchaseAmount: 'Xarid miqdori',
                paymentMethod: 'To\'lov turi',
                list: 'Mijozlar ro\'yxati',
                amount: 'Miqdori',
                sum: 'Summasi'
            },
            employeeStat: 'Ishchilar statistikasi',
            supplier: 'Yetkazib beruvchilar statistikasi',
            info: {
                sale: 'tanlangan davr uchun savdo mavjud emas',
                debt: 'tanlangan davr uchun qarz mavjud emas',
                gap: 'Savdo va ushbu savdoni statistikada ko\'rinishi orasida 5 daqiqalik interval mavjud'
            },
            weekday: {
                sun: 'Yakshanba',
                mon: 'Dushanba',
                tue: 'Seshanba',
                wed: 'Chorshanba',
                thu: 'Payshanba',
                fri: 'Juma',
                sat: 'Shanba'
            },
            weekdays: [
                'Yak',
                'Du',
                'Se',
                'Cho',
                'Pay',
                'Ju',
                'Sh'
            ],
            month: {
                Jan: 'Yanvar',
                Feb: 'Fevral',
                Mar: 'Mart',
                Apr: 'Aprel',
                May: 'May',
                Jun: 'Iyun',
                Jul: 'Iyul',
                Aug: 'Avgust',
                Sep: 'Sentyabr',
                Oct: 'Oktyabr',
                Nov: 'Noyabr',
                Dec: 'Dekabr',
            },
            title: "Statistika",
            type: {
                statByDay: 'Kunlik',
                statByMonth: 'Oylik',
                statByYear: 'Yillik',
                hourly: 'Soatlar bo\'yicha',
                daily: 'Kunlar bo\'yicha',
                weekly: 'Hafta bo\'yicha',
                monthly: 'Oylar bo\'yicha',

            },
            xaxis: {
                hour: 'Soat',
                day: 'Kun',
                month: 'Oy',
                year: 'Yil',
            },
            yaxis: 'Jami',
        },
        supplier: {
            choose: "Yetkazib beruvchini tanlang",
            title: "Yetkazib beruvchi",
            add: "Yetkazib beruvchi qo'shish",
            hasDebts: "Ushbu yetkazib beruvchidan qarzimiz bor",
            type: "Turi",
            info: "Yetkazib beruvchi haqida ma'lumot",
            deleteSupplierWarning: "Diqqat! Ushbu Yetkazib beruvchi tizimdan butunlay olib tashlanadi. Tasdiqlay olasizmi?",
            ourTotalDebt: "Umumiy qarzimiz"

        },
        unitOfMeasure: {
            additionalUnitOfMeasurement: "Qo'shimcha o'lchov birligi",
            comparison: "Taqqoslash",
            short: "O'l. birlik",
            choose: "O'lchov birligini tanlang",
            unitOfMeasure: "O'lchov birligi",

            // weight
            g: "g",
            kg: "kg",

            // liquid
            ml: "mL",
            l: "L",

            // length
            mm: "mm",
            cm: "cm",
            m: "m",
            km: "km",
            ft: "fut",

            // cubic meter
            m3: "㎥",

            // pic
            pc: "dona",
        },
        user: {
            email: "Email",
            emailForResetPassword: "Elektron pochta manzilingizni kiriting va biz sizga parolingizni tiklash uchun havola yuboramiz.",
            emailSent: "Parolni tiklash uchun havola elektron pochtangizga yuborildi. Havolani amal qilish muddati 1 soat.\n Agar sizga xat bormagan bo'lsa, spam papkasini tekshiring yoki",
            emailSentToEmployee: "Xodimning elektron pochtasiga login parolini o'rnatish uchun havola yuborildi. Havolani amal qilish muddati 1 soat",
            tryAgain: "qayta urinib ko'ring",
            send: "Yuborish",
            password: "Parol",
            newPassword: "Yangi parol",
            repeatPassword: "Parolni tasdiqlang",
            resetPassword: "Parolni tiklash",
            forgotPassword: "Parolni unutdingizmi?",
            passwordChanged: "Parolingiz muvaffaqiyatli o'zgartirildi",
            resetTokenExpired: "Ushbu havolaning muddati tugagan yoki allaqachon ishlatilgan,",
            errors: {
                emailExists: "Ushbu email tizimda mavjud. Boshqasini kiriting",
            },
        },
        validator: {
            required: "To'ldiring",
            choose: "Birini tanlang",
            type: {
                int: "Butun son kiriting",
                number: "Raqam ishlatilishi kerak",
                email: "To'g'ri email kiriting",
                strongPassword: "Parolda raqam va harflar ishlating. Kamida 8 xonadan iborat bo'lishi shart",
                phone: "To'g'ri telefon raqamini kiriting",
                date: "Noto'g'ri sana kiritildi",
                notEnoughProductsInWarehouse: "Omborda mahsulotlar yetmaydi",
                thirteenDigit: "13 xonalik raqam kiriting",
                amount: "Noto'g'ri miqdor kiritildi"
            },
        },
        warehouse: {
            title: "Ombor",
            add: "Ombor qo'shish",
            name: "Ombor nomi",
            deleteWarning: "O'chirilayotgan omborda mahsulorlar bor. Iltimos, mahsulotlarni boshqa omborga ko'chiring!",
            choose: "Omborni tanlang",
            remainder: "Qoldiq",
            amountSalePrice: "Sotish narxidagi summasi",
            amountPurchasePrice: "Xarid narxidagi summasi",
            TotalAmountProducts: "Umumiy maxsulotlar soni",
            residueInWarehouse: 'Ombordagi qoldiq'
        },
    }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
})

// const loadedLanguages = ['en'] // our default language that is preloaded

function set(lang) {
    if (!isValid(lang)) {
        return
    }

    i18n.locale = lang
    // axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

function isValid(lang) {
    return i18n.availableLocales.includes(lang)
}

function getUrl(url) {
    return '/' + i18n.locale + '/' + url
}

function toUrl(url) {
    router.push(getUrl(url))
}

function getCurrentRoute() {
    return router.currentRoute
}

function flash(text, type) {
    Vue.prototype.$flashStorage.flash(i18n.t(text), type, {timeout: 8000})
}

export default {i18n, i18nHelper: {set, isValid, getUrl, toUrl, flash, getCurrentRoute}}

// export default {set, i18n}

// export function () {
//
// }

// export function loadLanguageAsync(lang) {
//     // If the same language
//     if (langPlugin.locale === lang) {
//         return Promise.resolve(set(lang))
//     }
//
//     // If the language was already loaded
//     if (loadedLanguages.includes(lang)) {
//         return Promise.resolve(set(lang))
//     }
//
//     // If the language hasn't been loaded yet
//     return import(/* webpackChunkName: "lang-[request]" */ `@/langPlugin/messages/${lang}.js`).then(
//         messages => {
//             langPlugin.setLocaleMessage(lang, messages.default)
//             loadedLanguages.push(lang)
//             return set(lang)
//         }
//     )
// }
